import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // debug: true,
    fallbackLng: "en",
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
    lng: "en",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          "Proposer Name": "Proposer Name",
          "Life Assured Name": "Life Assured Name",
          "Proposer date of birth": "Proposer date of birth",
          "Registered Email Address": "Registered Email Address",
          "Mobile Number": "Mobile Number",
          Education: "Education",
          Occupation: "Occupation",
          "Income (per annum)": "Income (per annum)",
          "Plan Name": "Plan Name",
          "Life CoverSum assured": "Life CoverSum assured",
          "Premium amount": "Premium amount",
          Frequency: "Frequency",
          "Premium paying term": "Premium paying term",
          "Policy term": "Policy term",
          "Start Your Journey": "Start Your Journey",
          "Reference No.": "Reference No.",
          Language: "Language",
          "I Agree": "I Agree",
          Disagree: "Disagree",
          "Personal Details": "Personal Details",
          "Policy Details": "Policy Details",
          "Video Consent": "Video Consent",
          "Please record your video consent by clicking Start and clearly reading the text displayed on the screen. When you're done, click Stop to complete the process.":
            "Please record your video consent by clicking Start and clearly reading the text displayed on the screen. When you're done, click Stop to complete the process.",
          "Policy Details 1": "Policy Details 1",
          "Policy Details 2": "Policy Details 2",
          "Policy Details 3": "Policy Details 3",
          "Policy Details 4": "Policy Details 4",
          "Policy Details 5": "Policy Details 5",
          "Policy Details 6": "Policy Details 6",
          "Policy Details 7": "Policy Details 7",
          "Policy Details 8": "Policy Details 8",
          "Policy Details 9": "Policy Details 9",
          "Policy Details 10": "Policy Details 10",
          "Please wait while we verify your recording":
            "Please wait while we verify your recording",
          Start: "Start",
          Stop: "Stop",
          "You have only one chance left to complete the verification.":
            "You have only one chance left to complete the verification.",
          "Max limit reached Please try after 24 hours":
            "Max limit reached. Please try after 24 hours.",
          Close: "Close",
          "Incorrect Input details. Please reach out to our sales representative. [ERR002]": "Incorrect Input details. Please reach out to our sales representative. [ERR002]",
          "Application number": "Application number",
          "Thank you for your response. Our representative will contact you soon.":
            "Thank you for your response. Our representative will contact you soon.",
          Cancel: "Cancel",
          "Location permission is denied by user":
            "Location permission is denied by user",
          "Please allow location service from browser settings to continue.":
            "Please allow location service from browser settings to continue.",
          "Error accessing location: User denied Geolocation. [ERR001]": "Error accessing location: User denied Geolocation. [ERR001]",
          "Unable to access camera or microphone. Please ensure you have all the necessary permissions. [ERR004]": "Unable to access camera or microphone. Please ensure you have all the necessary permissions. [ERR004]",
          "Record again": "Record again",
          "The spoken text is inaccurate. Please try recording again.":
            "The spoken text is inaccurate. Please try recording again.",
          "Return to homepage": "Return to homepage",
          "Your video consent was not successfully recorded. Please restart the process and try again.":
            "Your video consent was not successfully recorded. Please restart the process and try again.",
          "Your video consent could not be recorded due to a device change. Please try again.": "Your video consent could not be recorded due to a device change. Please try again.",
          videoVerificationMessage:
            "Thank you for completing the Video Verification for <br className='hidden md:block' /> Application Number {{appNo}}",
          customerCareMessage:
            'Please refer to your policy documents after issuance to check the terms and conditions <br className="hidden md:block" /> during the 30-day free look period and contact us if you have any concerns.<br className="hidden md:block" /> You may reach out to us on 18002660 or visit our website/mobile app.',
          "Please wait while we verify your recording.":
            "Please wait while we verify your recording.",
          timeRemaining: "Time remaining {{timer}} seconds",
          "Please hold on while we verify your video":
            "Please hold on while we verify your video",
          "Face detected": "Face detected",
          "Multiple faces detected. Please make sure only one person is in view!":
            "Multiple faces detected. Please make sure only one person is in view!",
          "Face Match Unsuccessful!": "Face Match Unsuccessful!",
          "Make sure a real person is in view and looking towards camera in a well-lit area!":
            "Make sure a real person is in view and looking towards camera in a well-lit area!",
          "No face detected. Please ensure your face is clearly visible.":
            "No face detected. Please ensure your face is clearly visible.",
          "You don't have camera permissions, Please give permissions manually":
            "You don't have camera permissions, Please give permissions manually",
          "Meeting connection failed": "Meeting connection failed",
          "Meeting connection disconnected abruptly":
            "Meeting connection disconnected abruptly",
          'I hereby give my consent and authorize ICICI Prudential Life Insurance Company by clicking on "Start Your Journey" button to use my photo and video footage for verification purpose and to share my photo and video footage provided herein on confidential basis with ICICI group and/or third-party agencies':
            'I hereby give my consent and authorize ICICI Prudential Life Insurance Company by clicking on "Start Your Journey" button to use my photo and video footage for verification purpose and to share my photo and video footage provided herein on confidential basis with ICICI group and/or third-party agencies',
          "Life assured gender": "Life assured gender",
          "Repeat Details": "Repeat Details",
          "Premium Amount(Inclusive of all applicable taxes)":
            "Premium Amount (Inclusive of all applicable taxes)",
          "Total Premium Amount(Inclusive of all applicable taxes)":
            "Total Premium Amount (Inclusive of all applicable taxes)",
          "Unable to fetch device details, Please try using another device.":
            "Unable to fetch device details, Please try using another device.",
          "Starting Your Journey...": "Starting Your Journey...",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR099]": "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR099]",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR003]": "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR003]",
          "Our services are temporarily unavailable. Please try again shortly.": "Our services are temporarily unavailable. Please try again shortly.",
          "Please provide a reason for disagreeing": "Please provide a reason for disagreeing",
          "Reason should be less than 100 characters and more than 20 characters": "Reason should be less than 100 characters and more than 20 characters",
          "Reason should only contain letters and numbers": "Reason should only contain letters and numbers",
          "Enter your reason for disagreeing here...": "Enter your reason for disagreeing here...",
          "Submit for Validation": "Submit for Validation",
          "Your journey is about to expire in one minute. Please complete any pending actions.": "Your journey is about to expire in one minute. Please complete any pending actions."
        },
      },
      hi: {
        translation: {
          "Proposer Name": "प्रस्तावक का नाम",
          "Life Assured Name": "जीवन बीमित का नाम",
          "Proposer date of birth": "प्रस्तावक की जन्म तिथि",
          "Registered Email Address": "पंजीकृत ईमेल पता",
          "Mobile Number": "मोबाइल नंबर",
          Education: "शिक्षा",
          Occupation: "पेशा",
          "Income (per annum)": "आय (प्रति वर्ष)",
          "Plan Name": "योजना का नाम",
          "Life CoverSum assured": "जीवन बीमासंपूर्ण बीमित राशि",
          "Premium amount": "प्रीमियम राशि",
          Frequency: "आवृत्ति",
          "Premium paying term": "प्रीमियम भुगतान अवधि",
          "Policy term": "पॉलिसी अवधि",
          "Start Your Journey": "अपने आवेदन की प्रक्रिया शुरू करें",
          "Reference No.": "संदर्भ संख्या",
          Language: "भाषा",
          "I Agree": "मैं सहमत हूं",
          Disagree: "असहमत",
          "Personal Details": "व्यक्तिगत विवरण",
          "Policy Details": "पॉलिसी विवरण",
          "Video Consent": "वीडियो सहमति",
          "Please record your video consent by clicking Start and clearly reading the text displayed on the screen. When you're done, click Stop to complete the process.":
            "कृपया प्रारंभ पर क्लिक करके और स्क्रीन पर प्रदर्शित पाठ को स्पष्ट रूप से पढ़कर अपना वीडियो सहमति रिकॉर्ड करें। जब आप समाप्त करें, तो प्रक्रिया पूरी करने के लिए रोकें पर क्लिक करें।",
          "Policy Details 1": "नीति विवरण १",
          "Policy Details 2": "नीति विवरण २",
          "Policy Details 3": "नीति विवरण ३",
          "Policy Details 4": "नीति विवरण ४",
          "Policy Details 5": "नीति विवरण ५",
          "Policy Details 6": "नीति विवरण ६",
          "Policy Details 7": "नीति विवरण ७",
          "Policy Details 8": "नीति विवरण ८",
          "Policy Details 9": "नीति विवरण ९",
          "Policy Details 10": "नीति विवरण १०",
          "Please wait while we verify your recording":
            "कृपया प्रतीक्षा करें जब तक हम आपकी रिकॉर्डिंग सत्यापित कर रहे हैं।",
          Start: "प्रारंभ करें",
          Stop: "रोकें",
          "You have only one chance left to complete the verification.":
            "सत्यापन पूरा करने के लिए आपके पास केवल एक और मौका बचा है।",
          "Max limit reached Please try after 24 hours":
            "अधिकतम सीमा पूरी हो गई है। कृपया 24 घंटे बाद पुनः प्रयास करें।",
          Close: "बंद करें",
          "Incorrect Input details. Please reach out to our sales representative. [ERR002]": "गलत इनपुट विवरण। कृपया हमारे बिक्री प्रतिनिधि से संपर्क करें। [ERR002]",
          "Application number": "आवेदन संख्या",
          "Thank you for your response. Our representative will contact you soon.":
            "आपकी प्रतिक्रिया के लिए धन्यवाद। हमारा प्रतिनिधि आपसे शीघ्र संपर्क करेगा।",
          Cancel: "रद्द करें",
          "Location permission is denied by user":
            "स्थान अनुमति उपयोगकर्ता द्वारा अस्वीकार की गई है।",
          "Please allow location service from browser settings to continue.":
            "कृपया ब्राउज़र सेटिंग्स से स्थान सेवा की अनुमति दें।",
          "Error accessing location: User denied Geolocation. [ERR001]": "स्थान तक पहुँचने में त्रुटि: उपयोगकर्ता ने जियोलोकेशन अस्वीकार किया। [ERR001]",
          "Unable to access camera or microphone. Please ensure you have all the necessary permissions. [ERR004]": "कैमरा या माइक्रोफ़ोन तक पहुंच नहीं मिल रही है। कृपया सुनिश्चित करें कि आपके पास सभी आवश्यक अनुमतियाँ हैं। [ERR004]",
          "Record again": "फिर से रिकॉर्ड करें।",
          "The spoken text is inaccurate. Please try recording again.":
            "बोला गया पाठ सटीक नहीं है। कृपया पुनः रिकॉर्डिंग का प्रयास करें।",
          "Return to homepage": "मुखपृष्ठ पर लौटें",
          "Your video consent was not successfully recorded. Please restart the process and try again.":
            "आपकी वीडियो सहमति सफलतापूर्वक रिकॉर्ड नहीं की गई। कृपया प्रक्रिया पुनः शुरू करें और पुनः प्रयास करें।",
          "Your video consent could not be recorded due to a device change. Please try again.": "डिवाइस बदलने के कारण आपकी वीडियो स्वीकृति रिकॉर्ड नहीं की जा सकी। कृपया फिर से प्रयास करें।",
          videoVerificationMessage:
            "वीडियो सत्यापन पूरा करने के लिए धन्यवाद <br className='hidden md:block' /> आवेदन संख्या {{appNo}}",
          customerCareMessage:
            'कृपया शर्तों और निबंधनों की जांच के लिए पॉलिसी जारी होने के बाद अपने दस्तावेज़ देखें <br className="hidden md:block" /> 30-दिन की मुफ़्त देखने की अवधि के दौरान और यदि कोई चिंता हो तो हमसे संपर्क करें।<br className="hidden md:block" /> आप हमसे 18002660 पर संपर्क कर सकते हैं या हमारी वेबसाइट/मोबाइल ऐप पर जा सकते हैं।',
          "Please wait while we verify your recording.":
            "कृपया प्रतीक्षा करें जब तक हम आपकी रिकॉर्डिंग को सत्यापित कर रहे हैं।",
          timeRemaining: "समय शेष {{timer}} सेकंड",
          "Please hold on while we verify your video":
            "कृपया थोड़ी देर रुकें हम आपके वीडियो की जांच करते हैं",
          "Face detected": "चेहरा पहचान लिया गया",
          "Multiple faces detected. ":
            "कई चेहरे पाए गए। कृपया सुनिश्चित करें कि केवल एक व्यक्ति दिखाई दे रहा है!",
          "Face Match Unsuccessful!": "चेहरे का मिलान असफल!",
          "Make sure a real person is in view and looking towards camera in a well-lit area!":
            "सुनिश्चित करें कि एक वास्तविक व्यक्ति अच्छी रोशनी वाले क्षेत्र में कैमरे की ओर देख रहा हो!",
          "No face detected. Please ensure your face is clearly visible.":
            "कोई चेहरा नहीं पाया गया। कृपया सुनिश्चित करें कि आपका चेहरा स्पष्ट रूप से दिखाई दे रहा है।",
          "You don't have camera permissions, Please give permissions manually":
            "आपके पास कैमरा अनुमतियाँ नहीं हैं, कृपया मैन्युअल रूप से अनुमतियाँ दें",
          "Meeting connection failed": "मीटिंग का कनेक्शन विफल हो गया",
          "Meeting connection disconnected abruptly":
            "मीटिंग का कनेक्शन अचानक से टूट गया",
          'I hereby give my consent and authorize ICICI Prudential Life Insurance Company by clicking on "Start Your Journey" button to use my photo and video footage for verification purpose and to share my photo and video footage provided herein on confidential basis with ICICI group and/or third-party agencies':
            'मैं यहां अपनी सहमति देता हूं और ICICI प्रूडेंशियल लाइफ इंश्योरेंस कंपनी को "अपने आवेदन की प्रक्रिया शुरू करें" बटन पर क्लिक करके मेरी फोटो और वीडियो फुटेज को सत्यापन उद्देश्य के लिए उपयोग करने और ICICI समूह और/या तृतीय-पक्ष एजेंसियों के साथ गोपनीय रूप से साझा करने के लिए अधिकृत करता हूं।',
          "Life assured gender": "जीवन बीमित का लिंग",
          "Repeat Details": "विवरण दोहराएं",
          "Premium Amount(Inclusive of all applicable taxes)":
            "प्रीमियम राशि (सभी लागू करों सहित)",
          "Total Premium Amount(Inclusive of all applicable taxes)":
            "कुल प्रीमियम राशि (सभी लागू करों सहित)",
          "Unable to fetch device details, Please try using another device.":
            "डिवाइस विवरण प्राप्त करने में असमर्थ, कृपया दूसरा डिवाइस उपयोग करने का प्रयास करें।",
          "Starting Your Journey...":
            "आपके आवेदन की प्रक्रिया शुरू हो रही है...",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR099]": "उफ़! कुछ त्रुटि हुई। कृपया हमारे बिक्री प्रतिनिधि से संपर्क करें या हमें vidassure@iciciprulife.com पर लिखें। [ERR099]",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR003]": "उफ़! कुछ त्रुटि हुई। कृपया हमारे बिक्री प्रतिनिधि से संपर्क करें या हमें vidassure@iciciprulife.com पर लिखें। [ERR003]",
          "Our services are temporarily unavailable. Please try again shortly.": "हमारी सेवाएं अस्थायी रूप से उपलब्ध नहीं हैं। कृपया थोड़ी देर बाद पुनः प्रयास करें।",
          "Please provide a reason for disagreeing": "कृपया असहमति का कारण दें",
          "Reason should be less than 100 characters and more than 20 characters": "कारण 100 वर्णों से कम और 20 वर्णों से अधिक होना चाहिए",
          "Reason should only contain letters and numbers": "कारण में केवल अक्षर और संख्याएँ होनी चाहिए",
          "Enter your reason for disagreeing here...": "यहां असहमति का कारण दर्ज करें...",
          "Submit for Validation": "मान्यता के लिए सबमिट करें",
          "Your journey is about to expire in one minute. Please complete any pending actions.": "आपकी यात्रा एक मिनट में समाप्त होने वाली है। कृपया अपने लंबित कार्य पूरे कर लें।"

        },
      },
      gu: {
        translation: {
          "Proposer Name": "પ્રસ્તાવકનું નામ",
          "Life Assured Name": "જીવન બીમિતનું નામ",
          "Proposer date of birth": "પ્રસ્તાવકની જન્મ તારીખ",
          "Registered Email Address": "નોંધાયેલ ઇમેઇલ સરનામું",
          "Mobile Number": "મોબાઇલ નંબર",
          Education: "શિક્ષણ",
          Occupation: "વ્યવસાય",
          "Income (per annum)": "આવક (દર વર્ષે)",
          "Plan Name": "યોજનાનું નામ",
          "Life CoverSum assured": "જીવન કવરકુલ સુનિશ્ચિત",
          "Premium amount": "પ્રીમિયમ રકમ",
          Frequency: "આવર્તન",
          "Premium paying term": "પ્રીમિયમ ચૂકવણી સમયગાળો",
          "Policy term": "પોલિસી સમયગાળો",
          "Start Your Journey": "તમારા અરજી પ્રક્રિયાની શરૂઆત કરો",
          "Reference No.": "સંદર્ભ નંબર",
          Language: "ભાષા",
          "I Agree": "હું સંમત છું",
          Disagree: "અસહમત",
          "Personal Details": "વ્યક્તિગત વિગતો",
          "Policy Details": "પોલિસી વિગતો",
          "Video Consent": "વીડિયો સંમતિ",
          "Please record your video consent by clicking Start and clearly reading the text displayed on the screen. When you're done, click Stop to complete the process.":
            "કૃપા કરીને સ્ટાર્ટ પર ક્લિક કરીને અને સ્ક્રીન પર દર્શાવેલ ટેક્સ્ટ વાંચીને તમારું વિડિઓ સંમતિ રેકોર્ડ કરો. જ્યારે તમે પૂરું કરો, ત્યારે પ્રક્રિયા પૂર્ણ કરવા માટે સ્ટોપ પર ક્લિક કરો.",
          "Policy Details 1": "પોલિસી વિગતો ૧",
          "Policy Details 2": "પોલિસી વિગતો ૨",
          "Policy Details 3": "પોલિસી વિગતો ૩",
          "Policy Details 4": "પોલિસી વિગતો ૪",
          "Policy Details 5": "પોલિસી વિગતો ૫",
          "Policy Details 6": "પોલિસી વિગતો ૬",
          "Policy Details 7": "પોલિસી વિગતો ૭",
          "Policy Details 8": "પોલિસી વિગતો ૮",
          "Policy Details 9": "પોલિસી વિગતો ૯",
          "Policy Details 10": "પોલિસી વિગતો ૧૦",
          "Please wait while we verify your recording":
            "કૃપા કરીને રાહ જુઓ જ્યારે અમે તમારી રેકોર્ડિંગને ચકાસી રહ્યા છીએ.",
          Start: "સ્ટાર્ટ",
          Stop: "સ્ટોપ",
          "You have only one chance left to complete the verification.":
            "તમે ચકાસણી પૂર્ણ કરવા માટે માત્ર એક જ તક બાકી છે.",
          "Max limit reached Please try after 24 hours":
            "મહત્તમ મર્યાદા પહોંચી ગઈ છે. કૃપા કરીને 24 કલાક પછી પ્રયત્ન કરો.",
          Close: "બંધ કરો",
          "Incorrect Input details. Please reach out to our sales representative. [ERR002]": "ખોટા ઇનપુટ વિગતો. કૃપા કરીને અમારા વેચાણ પ્રતિનિધિનો સંપર્ક કરો. [ERR002]",
          "Application number": "અરજી નંબર",
          "Thank you for your response. Our representative will contact you soon.":
            "તમારા પ્રતિસાદ માટે આભાર. અમારો પ્રતિનિધિ ટૂંક સમયમાં તમારો સંપર્ક કરશે.",
          Cancel: "રદ કરો",
          "Location permission is denied by user":
            "સ્થાન પરવાનગી વપરાશકર્તા દ્વારા નકારવામાં આવી છે.",
          "Please allow location service from browser settings to continue.":
            "કૃપા કરીને બ્રાઉઝરની સેટિંગ્સમાંથી સ્થાન સેવાને ચાલુ કરો.",
          "Error accessing location: User denied Geolocation. [ERR001]": "સ્થાન એક્સેસ કરતી વખતે ભૂલ: વપરાશકર્તાએ જીયોલોકેશન નકારી કાઢ્યું. [ERR001]",
          "Unable to access camera or microphone. Please ensure you have all the necessary permissions. [ERR004]": "કૅમેરા અથવા માઇક્રોફોન સુધી પહોંચ શક્ય નથી. કૃપા કરીને ખાતરી કરો કે તમારી પાસે જરૂરી તમામ પરવાનગીઓ છે. [ERR004]",
          "Record again": "ફરીથી રેકોર્ડ કરો",
          "The spoken text is inaccurate. Please try recording again.":
            "બોલેલું લખાણ ખોટું છે. ફરીથી રેકોર્ડ કરવાનો પ્રયાસ કરો.",
          "Return to homepage": "મૂળ પૃષ્ઠ પર પાછા જાઓ",
          "Your video consent was not successfully recorded. Please restart the process and try again.":
            "તમારી વિડિયો મંજુરી સફળતાપૂર્વક રેકોર્ડ થઈ નથી. પ્રક્રિયાને ફરી શરૂ કરો અને ફરીથી પ્રયાસ કરો.",
          "Your video consent could not be recorded due to a device change. Please try again.": "ડિવાઈસ બદલવાની કારણે તમારું વીડિયો સંમતિ રેકોર્ડ થઈ શકી નથી. કૃપા કરીને ફરી પ્રયાસ કરો.",
          videoVerificationMessage:
            "વિડીયો ચકાસણી પૂર્ણ કરવા માટે આભાર <br className='hidden md:block' /> એપ્લિકેશન નંબર {{appNo}}",
          customerCareMessage:
            'તમારી પોલિસી જારી થયા પછી શરતો અને નિયમો તપાસવા માટે દસ્તાવેજો જુઓ <br className="hidden md:block" /> 30-દિવસની મુક્ત જોવાની અવધિ દરમિયાન અને કોઈ ચિંતા હોય તો અમારો સંપર્ક કરો।<br className="hidden md:block" /> તમે અમારો સંપર્ક 18002660 પર કરી શકો છો અથવા અમારી વેબસાઇટ/મોબાઇલ એપ્લિકેશન મુલાકાત લો.',
          "Please wait while we verify your recording.":
            "કૃપા કરીને રાહ જુઓ જયારે અમે તમારી રેકોર્ડિંગ ચકાસી રહ્યા છીએ.",
          timeRemaining: "સમય બાકી {{timer}} સેકન્ડ",
          "Please hold on while we verify your video":
            "કૃપા કરીને થોડીવાર રાહ જુઓ અમે તમારું વિડિઓ ચકાસી રહ્યા છીએ",
          "Face detected": "ચહેરો મળ્યો",
          "Multiple faces detected. Please make sure only one person is in view!":
            "બહુવિધ ચહેરાઓ મળ્યાં. કૃપા કરીને ખાતરી કરો કે માત્ર એક જ વ્યક્તિ દૃશ્યમાં છે!",
          "Face Match Unsuccessful!": "ચહેરો મેચ અસફળ!",
          "Make sure a real person is in view and looking towards camera in a well-lit area!":
            "ખાતરી કરો કે કોઈ વાસ્તવિક વ્યક્તિ સારી રીતે પ્રકાશિત વિસ્તારમાં કેમેરા તરફ જોઈ રહી છે અને દૃશ્યમાન છે!",
          "No face detected. Please ensure your face is clearly visible.":
            "કોઈ ચહેરો મળ્યો નથી. કૃપા કરીને ખાતરી કરો કે તમારો ચહેરો સ્પષ્ટ દેખાય છે.",
          "You don't have camera permissions, Please give permissions manually":
            "તમારી પાસે કેમેરાની પરવાનગીઓ નથી, કૃપા કરીને મેન્યુઅલી પરવાનગીઓ આપો",
          "Meeting connection failed": "મીટિંગ કનેક્શન નિષ્ફળ ગયું",
          "Meeting connection disconnected abruptly":
            "મીટિંગ કનેક્શન અચાનક તૂટી ગયું",
          'I hereby give my consent and authorize ICICI Prudential Life Insurance Company by clicking on "Start Your Journey" button to use my photo and video footage for verification purpose and to share my photo and video footage provided herein on confidential basis with ICICI group and/or third-party agencies':
            'હું અહીં મારી સંમતિ આપું છું અને ICICI પ્રુડેન્શિયલ લાઇફ ઇનશ્યોરન્સ કંપનીને "તમારા અરજી પ્રક્રિયાની શરૂઆત કરો" બટન ક્લિક કરીને મારી ફોટો અને વિડિયો ફૂટેજને ચકાસણી હેતુ માટે ઉપયોગ કરવા અને ICICI ગ્રુપ અને/અથવા તૃતીય પક્ષ એજન્સીઓ સાથે ગુપ્તરૂપે શેર કરવાની મંજૂરી આપું છું.',
          "Life assured gender": "જીવન વિમિતનું લિંગ",
          "Repeat Details": "વિગત પુનરાવૃત કરો",
          "Premium Amount(Inclusive of all applicable taxes)":
            "પ્રિમિયમ રકમ (બધા લાગુ કર સહિત)",
          "Total Premium Amount(Inclusive of all applicable taxes)":
            "કુલ પ્રિમિયમ રકમ (બધા લાગુ કર સહિત)",
          "Unable to fetch device details, Please try using another device.":
            "ડિવાઇસ વિગતો મેળવવામાં અસમર્થ, કૃપા કરીને બીજું ડિવાઇસ ઉપયોગ કરો.",
          "Starting Your Journey...": "તમારા અરજીની પ્રક્રિયા શરૂ થઈ રહી છે...",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR099]": "અરે! કેટલીક ભૂલ થઈ. કૃપા કરીને અમારી વેચાણ પ્રતિનિધિનો સંપર્ક કરો અથવા અમને vidassure@iciciprulife.com પર લખો. [ERR099]",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR003]": "અરે! કેટલીક ભૂલ થઈ. કૃપા કરીને અમારી વેચાણ પ્રતિનિધિનો સંપર્ક કરો અથવા અમને vidassure@iciciprulife.com પર લખો. [ERR003]",
          "Our services are temporarily unavailable. Please try again shortly.": "અમારી સેવાઓ અસ્થાયી રીતે ઉપલબ્ધ નથી. કૃપા કરીને થોડીવાર પછી ફરી પ્રયત્ન કરો.",
          "Please provide a reason for disagreeing": "કૃપા કરીને અસહમતિ કારણ દાખલ કરો",
          "Reason should be less than 100 characters and more than 20 characters": "કારણ ૧૦૦ અક્ષરોથી ઓછું અને ૨૦ અક્ષરોથી વધુ હોવું જોઈએ",
          "Reason should only contain letters and numbers": "કારણમાં ફક્ત અક્ષરો અને આંકડા હોવા જોઈએ",
          "Enter your reason for disagreeing here...": "અસંમત થવાનું કારણ અહીં દાખલ કરો...",
          "Submit for Validation": "માન્યતા માટે સબમિટ કરો",
          "Your journey is about to expire in one minute. Please complete any pending actions.": "તમારી મુસાફરી એક મિનિટમાં સમાપ્ત થવાની છે. કૃપા કરીને કોઈ પણ બાકી કામગીરી પૂર્ણ કરો."

        },
      },
      pa: {
        translation: {
          "Proposer Name": "ਪ੍ਰਸਤਾਵਕ ਦਾ ਨਾਮ",
          "Life Assured Name": "ਜੀਵਨ ਬੀਮਿਤ ਦਾ ਨਾਮ",
          "Proposer date of birth": "ਪ੍ਰਸਤਾਵਕ ਦੀ ਜਨਮ ਤਾਰੀਖ",
          "Registered Email Address": "ਰਜਿਸਟਰਡ ਈਮੇਲ ਪਤਾ",
          "Mobile Number": "ਮੋਬਾਈਲ ਨੰਬਰ",
          Education: "ਸਿੱਖਿਆ",
          Occupation: "ਪੇਸ਼ਾ",
          "Income (per annum)": "ਆਮਦਨ (ਸਲਾਨਾ)",
          "Plan Name": "ਯੋਜਨਾ ਦਾ ਨਾਮ",
          "Life CoverSum assured": "ਜੀਵਨ ਕਵਰਕੁੱਲ ਬੀਮਾ",
          "Premium amount": "ਪ੍ਰੀਮੀਅਮ ਰਕਮ",
          Frequency: "ਆਵਿਰਤੀ",
          "Premium paying term": "ਪ੍ਰੀਮੀਅਮ ਅਦਾਇਗੀ ਮਿਆਦ",
          "Policy term": "ਪਾਲਸੀ ਮਿਆਦ",
          "Start Your Journey": "ਆਪਣੇ ਅਰਜ਼ੀ ਦੀ ਪ੍ਰਕਿਰਿਆ ਸ਼ੁਰੂ ਕਰੋ",
          "Reference No.": "ਸੰਦਰਭ ਨੰਬਰ",
          Language: "ਭਾਸ਼ਾ",
          "I Agree": "ਮੈਂ ਸਹਿਮਤ ਹਾਂ",
          Disagree: "ਅਸਹਿਮਤ",
          "Personal Details": "ਵਿਅਕਤੀਗਤ ਵੇਰਵੇ",
          "Policy Details": "ਪਾਲਸੀ ਵੇਰਵੇ",
          "Video Consent": "ਵੀਡੀਓ ਸਹਿਮਤੀ",
          "Please record your video consent by clicking Start and clearly reading the text displayed on the screen. When you're done, click Stop to complete the process.":
            "ਕਿਰਪਾ ਕਰਕੇ ਸ਼ੁਰੂ ਕਰੋ 'ਤੇ ਕਲਿੱਕ ਕਰਕੇ ਅਤੇ ਸਕ੍ਰੀਨ 'ਤੇ ਦਿਖਾਏ ਗਏ ਪਾਠ ਨੂੰ ਸਪੱਸ਼ਟ ਤੌਰ 'ਤੇ ਪੜ੍ਹ ਕੇ ਆਪਣੀ ਵੀਡੀਓ ਸਹਿਮਤੀ ਰਿਕਾਰਡ ਕਰੋ। ਜਦੋਂ ਤੁਸੀਂ ਮੁਕੰਮਲ ਕਰ ਲਵੋ, ਤੰਦਰੁਸਤ ਕਰਨ ਲਈ 'ਰੋਕੋ' 'ਤੇ ਕਲਿੱਕ ਕਰੋ।",
          "Policy Details 1": "ਪਾਲੀਸੀ ਵੇਰਵੇ ੧",
          "Policy Details 2": "ਪਾਲੀਸੀ ਵੇਰਵੇ ੨",
          "Policy Details 3": "ਪਾਲੀਸੀ ਵੇਰਵੇ ੩",
          "Policy Details 4": "ਪਾਲੀਸੀ ਵੇਰਵੇ ੪",
          "Policy Details 5": "ਪਾਲੀਸੀ ਵੇਰਵੇ ੫",
          "Policy Details 6": "ਪਾਲੀਸੀ ਵੇਰਵੇ ੬",
          "Policy Details 7": "ਪਾਲੀਸੀ ਵੇਰਵੇ ੭",
          "Policy Details 8": "ਪਾਲੀਸੀ ਵੇਰਵੇ ੮",
          "Policy Details 9": "ਪਾਲੀਸੀ ਵੇਰਵੇ ੯",
          "Policy Details 10": "ਪਾਲੀਸੀ ਵੇਰਵੇ ੧੦",
          "Please wait while we verify your recording":
            "ਕਿਰਪਾ ਕਰਕੇ ਇੰਤਜ਼ਾਰ ਕਰੋ ਜਦੋਂ ਤੱਕ ਅਸੀਂ ਤੁਹਾਡੀ ਰਿਕਾਰਡਿੰਗ ਨੂੰ ਸਹੀ ਕਰ ਰਹੇ ਹਾਂ।",
          Start: "ਸ਼ੁਰੂ ਕਰੋ",
          Stop: "ਰੋਕੋ",
          "You have only one chance left to complete the verification.":
            "ਤੁਹਾਡੇ ਕੋਲ ਪ੍ਰਮਾਣੀਕਰਨ ਪੂਰਾ ਕਰਨ ਲਈ ਸਿਰਫ ਇੱਕ ਮੌਕਾ ਬਾਕੀ ਹੈ।",
          "Max limit reached Please try after 24 hours":
            "ਵੱਧ ਤੋਂ ਵੱਧ ਸੀਮਾ ਪਹੁੰਚ ਗਈ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ 24 ਘੰਟਿਆਂ ਬਾਅਦ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
          Close: "ਬੰਦ ਕਰੋ",
          "Incorrect Input details. Please reach out to our sales representative. [ERR002]": "ਗਲਤ ਇਨਪੁੱਟ ਵੇਰਵੇ। ਕਿਰਪਾ ਕਰਕੇ ਸਾਡੇ ਵਿਕਰੀ ਪ੍ਰਤੀਨਿਧੀ ਨਾਲ ਸੰਪਰਕ ਕਰੋ। [ERR002]",
          "Application number": "ਅਰਜ਼ੀ ਨੰਬਰ",
          "Thank you for your response. Our representative will contact you soon.":
            "ਤੁਹਾਡੀ ਪ੍ਰਤਿਕ੍ਰਿਆ ਲਈ ਧੰਨਵਾਦ। ਸਾਡਾ ਪ੍ਰਤੀਨਿਧੀ ਜਲਦ ਹੀ ਤੁਹਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੇਗਾ।",
          Cancel: "ਰੱਦ ਕਰੋ",
          "Location permission is denied by user":
            "ਲੋਕੇਸ਼ਨ ਅਨੁਮਤੀ ਯੂਜ਼ਰ ਦੁਆਰਾ ਅਸਵੀਕਾਰ ਕੀਤੀ ਗਈ ਹੈ।",
          "Please allow location service from browser settings to continue.":
            "ਜਾਰੀ ਰੱਖਣ ਲਈ ਬ੍ਰਾਉਜ਼ਰ ਸੈਟਿੰਗਾਂ ਵਿੱਚੋਂ ਲੋਕੇਸ਼ਨ ਸੇਵਾ ਦੀ ਇਜਾਜ਼ਤ ਦਿਓ।",
          "Error accessing location: User denied Geolocation. [ERR001]": "ਲੋਕੇਸ਼ਨ ਐਕਸੈੱਸ ਕਰਨ ਦੌਰਾਨ ਗਲਤੀ: ਉਪਭੋਗਤਾ ਨੇ ਜਿਓਲੋਕੇਸ਼ਨ ਨੂੰ ਅਸਵੀਕਾਰ ਕੀਤਾ। [ERR001]",
          "Unable to access camera or microphone. Please ensure you have all the necessary permissions. [ERR004]": "ਕੈਮਰਾ ਜਾਂ ਮਾਈਕ੍ਰੋਫੋਨ ਤੱਕ ਪਹੁੰਚ ਨਹੀਂ ਮਿਲ ਰਹੀ। ਕਿਰਪਾ ਕਰਕੇ ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਤੁਹਾਡੇ ਕੋਲ ਸਾਰੀਆਂ ਲੋੜੀਂਦੀਆਂ ਇਜਾਜ਼ਤਾਂ ਹਨ। [ERR004]",
          "Record again": "ਮੁੜ ਰਿਕਾਰਡ ਕਰੋ",
          "The spoken text is inaccurate. Please try recording again.":
            "ਬੋਲੇ ਗਏ ਪਾਠ ਵਿੱਚ ਗਲਤੀ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਮੁੜ ਰਿਕਾਰਡ ਕਰਨ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
          "Return to homepage": "ਮੁੱਖ ਪੇਜ 'ਤੇ ਵਾਪਸ ਜਾਓ",
          "Your video consent was not successfully recorded. Please restart the process and try again.":
            "ਤੁਹਾਡੀ ਵੀਡੀਓ ਸਹਿਮਤੀ ਸਫਲਤਾਪੂਰਵਕ ਰਿਕਾਰਡ ਨਹੀਂ ਹੋਈ। ਕਿਰਪਾ ਕਰਕੇ ਪ੍ਰਕਿਰਿਆ ਮੁੜ ਸ਼ੁਰੂ ਕਰੋ ਅਤੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
          "Your video consent could not be recorded due to a device change. Please try again.": "ਜੰਤਰ ਬਦਲਣ ਕਾਰਨ ਤੁਹਾਡੀ ਵੀਡੀਓ ਸਹਿਮਤੀ ਰਿਕਾਰਡ ਨਹੀਂ ਹੋ ਸਕੀ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
          videoVerificationMessage:
            "ਵੀਡੀਓ ਦੀ ਪੁਸ਼ਟੀ ਕਰਨ ਲਈ ਧੰਨਵਾਦ <br className='hidden md:block' /> ਅਰਜ਼ੀ ਨੰਬਰ {{appNo}}",
          customerCareMessage:
            'ਆਪਣੀ ਪਾਲਿਸੀ ਜਾਰੀ ਹੋਣ ਤੋਂ ਬਾਅਦ ਸ਼ਰਤਾਂ ਅਤੇ ਨਿਯਮਾਂ ਦੀ ਜਾਂਚ ਕਰਨ ਲਈ ਦਸਤਾਵੇਜ਼ ਵੇਖੋ <br className="hidden md:block" /> 30-ਦਿਨ ਦੀ ਮੁਫ਼ਤ ਵੇਖਣ ਦੀ ਮਿਆਦ ਦੌਰਾਨ ਅਤੇ ਜੇਕਰ ਕੋਈ ਚਿੰਤਾ ਹੋਵੇ ਤਾਂ ਸਾਡੇ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।<br className="hidden md:block" /> ਤੁਸੀਂ ਸਾਡੇ ਨਾਲ 18002660 \'ਤੇ ਸੰਪਰਕ ਕਰ ਸਕਦੇ ਹੋ ਜਾਂ ਸਾਡੀ ਵੈੱਬਸਾਈਟ/ਮੋਬਾਈਲ ਐਪ ਉੱਤੇ ਜਾ ਸਕਦੇ ਹੋ।',
          "Please wait while we verify your recording.":
            "ਕਿਰਪਾ ਕਰਕੇ ਉਡੀਕ ਕਰੋ ਜਦੋਂ ਤਕ ਅਸੀਂ ਤੁਹਾਡੀ ਰਿਕਾਰਡਿੰਗ ਦੀ ਪੁਸ਼ਟੀ ਕਰ ਰਹੇ ਹਾਂ।",
          timeRemaining: "ਸਮਾਂ ਬਾਕੀ {{timer}} ਸੈਕਿੰਡ",
          "Please hold on while we verify your video":
            "ਕ੍ਰਿਪਾ ਕਰਕੇ ਥੋੜਾ ਸਮਾਂ ਰੁਕੋ ਜਦੋਂ ਤੱਕ ਅਸੀਂ ਤੁਹਾਡੇ ਵੀਡੀਓ ਦੀ ਜਾਂਚ ਕਰਦੇ ਹਾਂ",
          "Face detected": "ਮੂੰਹ ਪਛਾਣਿਆ ਗਿਆ",
          "Multiple faces detected. Please make sure only one person is in view!":
            "ਬਹੁਤ ਸਾਰੇ ਮੂੰਹ ਪਛਾਣੇ ਗਏ। ਕ੍ਰਿਪਾ ਕਰਕੇ ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਸਿਰਫ ਇੱਕ ਵਿਅਕਤੀ ਦਿਖਾਈ ਦੇ ਰਿਹਾ ਹੈ!",
          "Face Match Unsuccessful!": "ਮੂੰਹ ਮਿਲਾਉਣਾ ਅਸਫਲ!",
          "Make sure a real person is in view and looking towards camera in a well-lit area!":
            "ਇਹ ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਇੱਕ ਅਸਲੀ ਵਿਅਕਤੀ ਚੰਗੀ ਰੋਸ਼ਨੀ ਵਾਲੇ ਖੇਤਰ ਵਿੱਚ ਨਜ਼ਰ ਆ ਰਿਹਾ ਹੈ ਅਤੇ ਕੈਮਰੇ ਵੱਲ ਦੇਖ ਰਿਹਾ ਹੈ!",
          "No face detected. Please ensure your face is clearly visible.":
            "ਕੋਈ ਮੂੰਹ ਨਹੀਂ ਪਛਾਣਿਆ ਗਿਆ। ਕ੍ਰਿਪਾ ਕਰਕੇ ਯਕੀਨੀ ਬਣਾਓ ਕਿ ਤੁਹਾਡਾ ਮੂੰਹ ਸਪੱਸ਼ਟ ਰੂਪ ਵਿੱਚ ਦਿਖਾਈ ਦੇ ਰਿਹਾ ਹੈ।",
          "You don't have camera permissions, Please give permissions manually":
            "ਤੁਹਾਡੇ ਕੋਲ ਕੈਮਰੇ ਦੀ ਆਗਿਆ ਨਹੀਂ ਹੈ, ਕ੍ਰਿਪਾ ਕਰਕੇ ਹਥੀਅਤ ਨਾਲ ਆਗਿਆ ਦਿਓ",
          "Meeting connection failed": "ਮੀਟਿੰਗ ਦਾ ਕਨੈਕਸ਼ਨ ਫੇਲ ਹੋ ਗਿਆ",
          "Meeting connection disconnected abruptly":
            "ਮੀਟਿੰਗ ਦਾ ਕਨੈਕਸ਼ਨ ਅਚਾਨਕ ਤੋੜਿਆ ਗਿਆ",
          'I hereby give my consent and authorize ICICI Prudential Life Insurance Company by clicking on "Start Your Journey" button to use my photo and video footage for verification purpose and to share my photo and video footage provided herein on confidential basis with ICICI group and/or third-party agencies':
            'ਮੈਂ ਇੱਥੇ ਆਪਣੀ ਸਹਿਮਤੀ ਦਿੰਦਾ ਹਾਂ ਅਤੇ ICICI ਪ੍ਰੂਡੈਂਸ਼ੀਅਲ ਲਾਈਫ ਇਨਸ਼ੋਰੈਂਸ ਕੰਪਨੀ ਨੂੰ "ਆਪਣੇ ਅਰਜ਼ੀ ਦੀ ਪ੍ਰਕਿਰਿਆ ਸ਼ੁਰੂ ਕਰੋ" ਬਟਨ ਤੇ ਕਲਿੱਕ ਕਰਕੇ ਮੇਰੀ ਫੋਟੋ ਅਤੇ ਵੀਡੀਓ ਫੁਟੇਜ ਦੀ ਜਾਂਚ ਉਦੇਸ਼ਾਂ ਲਈ ਵਰਤਣ ਅਤੇ ICICI ਸਮੂਹ ਅਤੇ/ਜਾਂ ਤੀਜੀ-ਪਾਸੇ ਏਜੰਸੀਜ਼ ਨਾਲ ਗੁਪਤ ਰੂਪ ਵਿੱਚ ਸਾਂਝਾ ਕਰਨ ਲਈ ਅਧਿਕਾਰਤ ਕਰਦਾ ਹਾਂ।',
          "Life assured gender": "ਜੀਵਨ ਬੀਮਾ ਕਰਵਾਇਆ ਵਿਅਕਤੀ ਦਾ ਲਿੰਗ",
          "Repeat Details": "ਵੇਰਵਾ ਦੁਹਰਾਓ",
          "Premium Amount(Inclusive of all applicable taxes)":
            "ਪ੍ਰੀਮੀਅਮ ਰਕਮ (ਸਭ ਲਾਗੂ ਕਰ ਸਮੇਤ)",
          "Total Premium Amount(Inclusive of all applicable taxes)":
            "ਕੁੱਲ ਪ੍ਰੀਮੀਅਮ ਰਕਮ (ਸਭ ਲਾਗੂ ਕਰ ਸਮੇਤ)",
          "Unable to fetch device details, Please try using another device.":
            "ਡਿਵਾਈਸ ਦੇ ਵੇਰਵੇ ਪ੍ਰਾਪਤ ਕਰਨ ਵਿੱਚ ਅਸਮਰਥ, ਕਿਰਪਾ ਕਰਕੇ ਦੂਸਰੇ ਡਿਵਾਈਸ ਨੂੰ ਵਰਤਣ ਦੀ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
          "Starting Your Journey...":
            "ਤੁਹਾਡੀ ਅਰਜ਼ੀ ਦੀ ਪ੍ਰਕਿਰਿਆ ਸ਼ੁਰੂ ਹੋ ਰਹੀ ਹੈ...",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR099]": "ਅਫ਼ਸੋਸ! ਕੁਝ ਗਲਤੀ ਹੋਈ। ਕਿਰਪਾ ਕਰਕੇ ਸਾਡੇ ਵਿਕਰੀ ਪ੍ਰਤੀਨਿਧੀ ਨਾਲ ਸੰਪਰਕ ਕਰੋ ਜਾਂ ਸਾਨੂੰ vidassure@iciciprulife.com 'ਤੇ ਲਿਖੋ। [ERR099]",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR003]": "ਅਫ਼ਸੋਸ! ਕੁਝ ਗਲਤੀ ਹੋਈ। ਕਿਰਪਾ ਕਰਕੇ ਸਾਡੇ ਵਿਕਰੀ ਪ੍ਰਤੀਨਿਧੀ ਨਾਲ ਸੰਪਰਕ ਕਰੋ ਜਾਂ ਸਾਨੂੰ vidassure@iciciprulife.com 'ਤੇ ਲਿਖੋ। [ERR003]",
          "Our services are temporarily unavailable. Please try again shortly.": "ਸਾਡੀਆਂ ਸੇਵਾਵਾਂ ਅਸਥਾਈ ਤੌਰ 'ਤੇ ਉਪਲਬਧ ਨਹੀਂ ਹਨ। ਕਿਰਪਾ ਕਰਕੇ ਕੁਝ ਸਮੇਂ ਬਾਅਦ ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ।",
          "Please provide a reason for disagreeing": "ਕ੍ਰਿਪਾ ਕਰਕੇ ਅસહમતિ ਕારણ ਦਾ ਦਾਖਲ ਕਰੋ",
          "Reason should be less than 100 characters and more than 20 characters": "ਕਾਰਨ 100 ਅੱਖਰਾਂ ਤੋਂ ਘੱਟ ਅਤੇ 20 ਅੱਖਰਾਂ ਤੋਂ ਵੱਧ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ",
          "Reason should only contain letters and numbers": "ਕਾਰਨ ਵਿੱਚ ਸਿਰਫ਼ ਅੱਖਰ ਅਤੇ ਅੰਕ ਹੀ ਹੋਣੇ ਚਾਹੀਦੇ ਹਨ",
          "Enter your reason for disagreeing here...": "ਇੱਥੇ ਅਸਹਿਮਤ ਹੋਣ ਦਾ ਕਾਰਨ ਦਰਜ ਕਰੋ...",
          "Submit for Validation": "ਮਨਜ਼ੂਰੀ ਲਈ ਜਮ੍ਹਾ ਕਰੋ",
          "Your journey is about to expire in one minute. Please complete any pending actions.": "ਤੁਹਾਡੀ ਯਾਤਰਾ ਇੱਕ ਮਿੰਟ ਵਿੱਚ ਸਮਾਪਤ ਹੋਣ ਵਾਲੀ ਹੈ। ਕਿਰਪਾ ਕਰਕੇ ਕੋਈ ਵੀ ਬਕਾਇਆ ਕੰਮ ਪੂਰੇ ਕਰੋ।"

        },
      },
      bn: {
        translation: {
          "Proposer Name": "আপনার আবেদন প্রক্রিয়া শুরু করুন",
          "Life Assured Name": "জীবন বীমাকৃতর নাম",
          "Proposer date of birth": "প্রস্তাবকের জন্ম তারিখ",
          "Registered Email Address": "নিবন্ধিত ইমেল ঠিকানা",
          "Mobile Number": "মোবাইল নম্বর",
          Education: "শিক্ষা",
          Occupation: "পেশা",
          "Income (per annum)": "আয় (প্রতি বছর)",
          "Plan Name": "পরিকল্পনার নাম",
          "Life CoverSum assured": "জীবন কভারসমস্ত নিশ্চিত",
          "Premium amount": "প্রিমিয়াম পরিমাণ",
          Frequency: "বারবার হওয়া",
          "Premium paying term": "প্রিমিয়াম প্রদানের মেয়াদ",
          "Policy term": "নীতির মেয়াদ",
          "Start Your Journey": "আপনার যাত্রা শুরু করুন",
          "Reference No.": "রেফারেন্স নম্বর",
          Language: "ভাষা",
          "I Agree": "আমি একমত",
          Disagree: "অসম্মতি",
          "Personal Details": "ব্যক্তিগত বিবরণ",
          "Policy Details": "নীতির বিবরণ",
          "Video Consent": "ভিডিও সম্মতি",
          "Please record your video consent by clicking Start and clearly reading the text displayed on the screen. When you're done, click Stop to complete the process.":
            "দয়া করে স্টার্টে ক্লিক করে এবং স্ক্রিনে প্রদর্শিত পাঠটি স্পষ্টভাবে পড়ে আপনার ভিডিও সম্মতি রেকর্ড করুন। শেষ হলে, স্টপে ক্লিক করুন প্রক্রিয়াটি সম্পূর্ণ করতে।",
          "Policy Details 1": "নীতি বিবরণ ১",
          "Policy Details 2": "নীতি বিবরণ ২",
          "Policy Details 3": "নীতি বিবরণ ৩",
          "Policy Details 4": "নীতি বিবরণ ৪",
          "Policy Details 5": "নীতি বিবরণ ৫",
          "Policy Details 6": "নীতি বিবরণ ৬",
          "Policy Details 7": "নীতি বিবরণ ৭",
          "Policy Details 8": "নীতি বিবরণ ৮",
          "Policy Details 9": "নীতি বিবরণ ৯",
          "Policy Details 10": "নীতি বিবরণ ১০",
          "Please wait while we verify your recording":
            "আপনার রেকর্ডিং যাচাই করা হচ্ছে, অনুগ্রহ করে অপেক্ষা করুন।",
          Start: "শুরু করুন",
          Stop: "থামুন",
          "You have only one chance left to complete the verification.":
            "যাচাইকরণ সম্পূর্ণ করার জন্য আপনার কাছে শুধুমাত্র একটি সুযোগ বাকি আছে।",
          "Max limit reached Please try after 24 hours":
            "সর্বাধিক সীমা পৌঁছেছে। দয়া করে 24 ঘন্টা পরে আবার চেষ্টা করুন।",
          Close: "বন্ধ করুন",
          "Incorrect Input details. Please reach out to our sales representative. [ERR002]": "ভুল ইনপুট বিশদ। অনুগ্রহ করে আমাদের বিক্রয় প্রতিনিধির সাথে যোগাযোগ করুন। [ERR002]",
          "Application number": "আবেদনের নম্বর",
          "Thank you for your response. Our representative will contact you soon.":
            "আপনার প্রতিক্রিয়ার জন্য ধন্যবাদ। আমাদের প্রতিনিধি শীঘ্রই আপনার সাথে যোগাযোগ করবে।",
          Cancel: "বাতিল করুন।",
          "Location permission is denied by user":
            "অবস্থান অনুমতি ব্যবহারকারী দ্বারা প্রত্যাখ্যান করা হয়েছে।",
          "Please allow location service from browser settings to continue.":
            "অনুগ্রহ করে ব্রাউজার সেটিংস থেকে অবস্থান পরিষেবা অনুমতি দিন।",
          "Error accessing location: User denied Geolocation. [ERR001]": "অবস্থান অ্যাক্সেস করার সময় ত্রুটি: ব্যবহারকারী জিওলোকেশন অস্বীকার করেছেন। [ERR001]",
          "Unable to access camera or microphone. Please ensure you have all the necessary permissions. [ERR004]": "ক্যামেরা বা মাইক্রোফোন অ্যাক্সেস করা যাচ্ছে না। অনুগ্রহ করে নিশ্চিত করুন যে আপনার সমস্ত প্রয়োজনীয় অনুমতি আছে। [ERR004]",
          "Record again": "আবার রেকর্ড করুন।",
          "The spoken text is inaccurate. Please try recording again.":
            "বলা পাঠটি সঠিক নয়। অনুগ্রহ করে আবার রেকর্ড করার চেষ্টা করুন।",
          "Return to homepage": "হোমপেজে ফিরে যান।",
          "Your video consent was not successfully recorded. Please restart the process and try again.":
            "আপনার ভিডিও সম্মতি সফলভাবে রেকর্ড করা হয়নি। অনুগ্রহ করে প্রক্রিয়াটি পুনরায় শুরু করুন এবং আবার চেষ্টা করুন।",
          "Your video consent could not be recorded due to a device change. Please try again.": "ডিভাইস পরিবর্তনের কারণে আপনার ভিডিও সম্মতি রেকর্ড করা যায়নি। অনুগ্রহ করে আবার চেষ্টা করুন।",
          videoVerificationMessage:
            "ভিডিও যাচাইকরণ সম্পন্ন করার জন্য ধন্যবাদ <br className='hidden md:block' /> আবেদন নম্বর {{appNo}}",
          customerCareMessage:
            'আপনার পলিসি ইস্যু হওয়ার পরে শর্তাবলী পরীক্ষা করতে নথিগুলি দেখুন <br className="hidden md:block" /> 30-দিনের বিনামূল্যে পর্যবেক্ষণ সময়কালে এবং যদি কোনো উদ্বেগ থাকে তবে আমাদের সাথে যোগাযোগ করুন।<br className="hidden md:block" /> আপনি আমাদের 18002660-এ পৌঁছাতে পারেন বা আমাদের ওয়েবসাইট/মোবাইল অ্যাপে যেতে পারেন।',
          "Please wait while we verify your recording.":
            "অনুগ্রহ করে অপেক্ষা করুন যতক্ষণ না আমরা আপনার রেকর্ডিং যাচাই করছি।",
          timeRemaining: "সময় বাকি {{timer}} সেকেন্ড",
          "Please hold on while we verify your video":
            "দয়া করে কিছু সময় অপেক্ষা করুন, আমরা আপনার ভিডিও যাচাই করছি",
          "Face detected": "মুখ সনাক্ত হয়েছে",
          "Multiple faces detected. Please make sure only one person is in view!":
            "একাধিক মুখ সনাক্ত হয়েছে। দয়া করে নিশ্চিত করুন যে শুধু এক ব্যক্তি দৃশ্যমান!",
          "Face Match Unsuccessful!": "মুখের মিল অযথা!",
          "Make sure a real person is in view and looking towards camera in a well-lit area!":
            "একটি ভালো আলোকিত স্থানে একজন প্রকৃত ব্যক্তি দৃশ্যমান এবং ক্যামেরার দিকে তাকিয়ে আছেন তা নিশ্চিত করুন!",
          "No face detected. Please ensure your face is clearly visible.":
            "কোনও মুখ সনাক্ত হয়নি। দয়া করে নিশ্চিত করুন যে আপনার মুখ স্পষ্টভাবে দৃশ্যমান।",
          "You don't have camera permissions, Please give permissions manually":
            "আপনার ক্যামেরা অনুমতি নেই, দয়া করে ম্যানুয়ালি অনুমতি দিন",
          "Meeting connection failed": "মিটিং সংযোগ ব্যর্থ হয়েছে",
          "Meeting connection disconnected abruptly":
            "মিটিং সংযোগ হঠাৎ বিচ্ছিন্ন হয়ে গেছে",
          'I hereby give my consent and authorize ICICI Prudential Life Insurance Company by clicking on "Start Your Journey" button to use my photo and video footage for verification purpose and to share my photo and video footage provided herein on confidential basis with ICICI group and/or third-party agencies':
            'আমি এখানে আমার সম্মতি প্রদান করছি এবং ICICI প্রুডেনশিয়াল লাইফ ইনস্যুরেন্স কোম্পানিকে "আপনার যাত্রা শুরু করুন" বোতামে ক্লিক করে আমার ছবি এবং ভিডিও ফুটেজ যাচাই করার উদ্দেশ্যে ব্যবহার করতে এবং ICICI গ্রুপ এবং/অথবা তৃতীয় পক্ষের সংস্থার সাথে গোপনীয়ভাবে ভাগ করার অনুমতি দিচ্ছি।',
          "Life assured gender": "বীমাকৃত ব্যক্তির লিঙ্গ",
          "Repeat Details": "বিস্তারিত পুনরাবৃত্তি করুন",
          "Premium Amount(Inclusive of all applicable taxes)":
            "প্রিমিয়াম পরিমাণ (সকল প্রযোজ্য করসহ)",
          "Total Premium Amount(Inclusive of all applicable taxes)":
            "মোট প্রিমিয়াম পরিমাণ (সকল প্রযোজ্য করসহ)",
          "Unable to fetch device details, Please try using another device.":
            "ডিভাইসের বিবরণ আনতে অক্ষম, দয়া করে অন্য ডিভাইস ব্যবহার করার চেষ্টা করুন।",
          "Starting Your Journey...": "আপনার আবেদন প্রক্রিয়া শুরু হচ্ছে...",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR099]": "ওহ! কিছু ভুল হয়েছে। অনুগ্রহ করে আমাদের বিক্রয় প্রতিনিধির সাথে যোগাযোগ করুন বা আমাদের vidassure@iciciprulife.com এ লিখুন। [ERR099]",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR003]": "ওহ! কিছু ভুল হয়েছে। অনুগ্রহ করে আমাদের বিক্রয় প্রতিনিধির সাথে যোগাযোগ করুন বা আমাদের vidassure@iciciprulife.com এ লিখুন। [ERR003]",
          "Our services are temporarily unavailable. Please try again shortly.": "আমাদের পরিষেবাগুলি অস্থায়ীভাবে অনুপলব্ধ। অনুগ্রহ করে কিছুক্ষণ পরে আবার চেষ্টা করুন।",
          "Please provide a reason for disagreeing": "অসহমতি কারণ দাখল করুন",
          "Reason should be less than 100 characters and more than 20 characters": "কারণ ১০০ অক্ষরের কম এবং ২০ অক্ষরের বেশি হতে হবে",
          "Reason should only contain letters and numbers": "কারণে শুধুমাত্র অক্ষর এবং সংখ্যা থাকা উচিত",
          "Enter your reason for disagreeing here...": "আপনার দ্বিমত পোষণের কারণ এখানে লিখুন...",
          "Submit for Validation": "যাচাইয়ের জন্য জমা দিন",
          "Your journey is about to expire in one minute. Please complete any pending actions.": "আপনার যাত্রা এক মিনিটের মধ্যে শেষ হতে চলেছে। দয়া করে যেকোনো মুলতুবি কাজ সম্পন্ন করুন।"

        },
      },
      mr: {
        translation: {
          "Proposer Name": "प्रस्तावक नाव",
          "Life Assured Name": "जीवन विमाधारकाचे नाव",
          "Proposer date of birth": "प्रस्तावकाची जन्मतारीख",
          "Registered Email Address": "नोंदणीकृत ईमेल पत्ता",
          "Mobile Number": "मोबाइल नंबर",
          Education: "शिक्षण",
          Occupation: "व्यवसाय",
          "Income (per annum)": "उत्पन्न (दर वर्षी)",
          "Plan Name": "योजनेचे नाव",
          "Life CoverSum assured": "जीवन कव्हरएकूण विमा",
          "Premium amount": "हप्ता रक्कम",
          Frequency: "वारंवारता",
          "Premium paying term": "हप्ता भरण्याची मुदत",
          "Policy term": "पॉलिसीची मुदत",
          "Start Your Journey": "तुमच्या अर्जाची प्रक्रिया सुरू करा",
          "Reference No.": "संदर्भ क्रमांक",
          Language: "भाषा",
          "I Agree": "मी सहमत आहे",
          Disagree: "असहमत",
          "Personal Details": "वैयक्तिक तपशील",
          "Policy Details": "पॉलिसी तपशील",
          "Video Consent": "व्हिडिओ सहमती",
          "Please record your video consent by clicking Start and clearly reading the text displayed on the screen. When you're done, click Stop to complete the process.":
            "कृपया प्रारंभावर क्लिक करून आणि स्क्रीनवर प्रदर्शित मजकूर स्पष्टपणे वाचून तुमची व्हिडिओ संमती रेकॉर्ड करा. पूर्ण झाल्यावर प्रक्रिया पूर्ण करण्यासाठी थांबवा क्लिक करा.",
          "Policy Details 1": "पॉलिसी तपशील १",
          "Policy Details 2": "पॉलिसी तपशील २",
          "Policy Details 3": "पॉलिसी तपशील ३",
          "Policy Details 4": "पॉलिसी तपशील ४",
          "Policy Details 5": "पॉलिसी तपशील ५",
          "Policy Details 6": "पॉलिसी तपशील ६",
          "Policy Details 7": "पॉलिसी तपशील ७",
          "Policy Details 8": "पॉलिसी तपशील ८",
          "Policy Details 9": "पॉलिसी तपशील ९",
          "Policy Details 10": "पॉलिसी तपशील १०",
          "Please wait while we verify your recording":
            "तुमची रेकॉर्डिंग सत्यापित होत आहे, कृपया थांबा.",
          Start: "प्रारंभ",
          Stop: "थांबवा",
          "You have only one chance left to complete the verification.":
            "सत्यापन पूर्ण करण्यासाठी तुमच्याकडे फक्त एक संधी शिल्लक आहे।",
          "Max limit reached Please try after 24 hours":
            "कमाल मर्यादा गाठली आहे. कृपया २४ तासांनी पुन्हा प्रयत्न करा।",
          Close: "बंद करा।",
          "Incorrect Input details. Please reach out to our sales representative. [ERR002]": "चुकीची इनपुट माहिती. कृपया आमच्या विक्री प्रतिनिधीशी संपर्क साधा. [ERR002]",
          "Application number": "अर्ज क्रमांक",
          "Thank you for your response. Our representative will contact you soon.":
            "तुमच्या प्रतिसादासाठी धन्यवाद। आमचे प्रतिनिधी लवकरच तुमच्याशी संपर्क साधतील।",
          Cancel: "रद्द करा।",
          "Location permission is denied by user":
            "स्थान परवानगी वापरकर्त्याने नाकारली आहे।",
          "Please allow location service from browser settings to continue.":
            "कृपया ब्राउझर सेटिंग्जमधून स्थान सेवा परवानगी द्या।",
          "Error accessing location: User denied Geolocation. [ERR001]": "स्थान प्रवेशात त्रुटी: वापरकर्त्याने जिओलोकेशन नाकारले. [ERR001]",
          "Unable to access camera or microphone. Please ensure you have all the necessary permissions. [ERR004]": "कॅमेरा किंवा मायक्रोफोनला प्रवेश मिळू शकत नाही. कृपया खात्री करा की सर्व आवश्यक परवानग्या दिल्या आहेत. [ERR004]",
          "Record again": "पुन्हा रेकॉर्ड करा।",
          "The spoken text is inaccurate. Please try recording again.":
            "बोललेला मजकूर अचूक नाही। कृपया पुन्हा रेकॉर्डिंग करण्याचा प्रयत्न करा।",
          "Return to homepage": "मुखपृष्ठावर परत जा।",
          "Your video consent was not successfully recorded. Please restart the process and try again.":
            "तुमची व्हिडिओ संमती यशस्वीरित्या रेकॉर्ड झाली नाही। कृपया प्रक्रिया पुन्हा सुरू करा आणि पुन्हा प्रयत्न करा।",
          "Your video consent could not be recorded due to a device change. Please try again.": "डिव्हाइस बदलल्यामुळे तुमची व्हिडिओ संमती रेकॉर्ड करता आली नाही. कृपया पुन्हा प्रयत्न करा.",
          videoVerificationMessage:
            "व्हिडिओ पडताळणी पूर्ण केल्याबद्दल धन्यवाद <br className='hidden md:block' /> अर्ज क्रमांक {{appNo}}",
          customerCareMessage:
            'कृपया तुमच्या पॉलिसी दस्तऐवजांमध्ये निर्गमनानंतर अटी व शर्ती तपासा <br className="hidden md:block" /> 30-दिवसांच्या विनामूल्य निरीक्षण कालावधीदरम्यान आणि तुम्हाला काही चिंता असल्यास आम्हाला संपर्क करा।<br className="hidden md:block" /> तुम्ही आम्हाला 18002660 वर पोहोचू शकता किंवा आमच्या वेबसाइट/मोबाइल अॅपला भेट देऊ शकता।',
          "Please wait while we verify your recording.":
            "कृपया थांबा जोपर्यंत आम्ही तुमच्या रेकॉर्डिंगची पडताळणी करत नाही.",
          timeRemaining: "वेळ उर्वरित {{timer}} सेकंद",
          "Please hold on while we verify your video":
            "कृपया थोडं थांबा, आम्ही आपलं व्हिडिओ तपासत आहोत",
          "Face detected": "मुख ओळखले",
          "Multiple faces detected. Please make sure only one person is in view!":
            "एकापेक्षा जास्त चेहरे ओळखले गेले. कृपया खात्री करा की फक्त एकच व्यक्ती दिसत आहे!",
          "Face Match Unsuccessful!": "मुख जुळवणं अयशस्वी!",
          "Make sure a real person is in view and looking towards camera in a well-lit area!":
            "चांगल्या प्रकाश असलेल्या ठिकाणी एक खरी व्यक्ती दृश्यमान आहे आणि कॅमेऱ्याकडे पाहत आहे याची खात्री करा!",
          "No face detected. Please ensure your face is clearly visible.":
            "कोणतंही मुख ओळखले नाही. कृपया खात्री करा की आपलं मुख स्पष्टपणे दिसत आहे.",
          "You don't have camera permissions, Please give permissions manually":
            "तुम्हाला कॅमेरा परवानगी नाही, कृपया मॅन्युअली परवानगी द्या",
          "Meeting connection failed": "मीटिंगचे कनेक्शन अयशस्वी झाले",
          "Meeting connection disconnected abruptly":
            "मीटिंगचे कनेक्शन अचानक तुटले",
          'I hereby give my consent and authorize ICICI Prudential Life Insurance Company by clicking on "Start Your Journey" button to use my photo and video footage for verification purpose and to share my photo and video footage provided herein on confidential basis with ICICI group and/or third-party agencies':
            'मी येथे माझी संमती देतो आणि ICICI प्रूडेंशियल लाइफ इन्शुरन्स कंपनीला "तुमच्या अर्जाची प्रक्रिया सुरू करा" बटण क्लिक करून माझा फोटो आणि व्हिडिओ फुटेज पडताळणीसाठी वापरण्याची आणि ICICI गट आणि/किंवा तृतीय-पक्ष एजन्सींसह गोपनीयपणे शेअर करण्याची परवानगी देतो.',
          "Life assured gender": "विमा घेतलेल्या व्यक्तीचे लिंग",
          "Repeat Details": "तपशील पुन्हा द्या",
          "Premium Amount(Inclusive of all applicable taxes)":
            "प्रिमियम रक्कम (सर्व लागू करांसह)",
          "Total Premium Amount(Inclusive of all applicable taxes)":
            "एकूण प्रिमियम रक्कम (सर्व लागू करांसह)",
          "Unable to fetch device details, Please try using another device.":
            "डिव्हाइस तपशील मिळवण्यात अयशस्वी, कृपया दुसरा डिव्हाइस वापरण्याचा प्रयत्न करा.",
          "Starting Your Journey...":
            "तुमच्या अर्जाची प्रक्रिया सुरू होत आहे...",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR099]": "अरे! काहीतरी त्रुटी झाली. कृपया आमच्या विक्री प्रतिनिधीशी संपर्क साधा किंवा आम्हाला vidassure@iciciprulife.com वर लिहा. [ERR099]",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR003]": "अरे! काहीतरी त्रुटी झाली. कृपया आमच्या विक्री प्रतिनिधीशी संपर्क साधा किंवा आम्हाला vidassure@iciciprulife.com वर लिहा. [ERR003]",
          "Our services are temporarily unavailable. Please try again shortly.": "आमच्या सेवा सध्या तात्पुरत्या उपलब्ध नाहीत. कृपया थोड्या वेळाने पुन्हा प्रयत्न करा.",
          "Please provide a reason for disagreeing": "असहमती कारण दाखल करा",
          "Reason should be less than 100 characters and more than 20 characters": "कारण १०० पेक्षा कमी आणि २० पेक्षा जास्त वर्णांचे असावे.",
          "Reason should only contain letters and numbers": "कारणामध्ये फक्त अक्षरे आणि अंक असावेत",
          "Enter your reason for disagreeing here...": "तुमचे असहमत असण्याचे कारण येथे प्रविष्ट करा...",
          "Submit for Validation": "मान्यतेसाठी सबमिट करा",
          "Your journey is about to expire in one minute. Please complete any pending actions.": "तुमचा प्रवास एका मिनिटात संपणार आहे. कृपया कोणतीही प्रलंबित कामे पूर्ण करा."

        },
      },
      kn: {
        translation: {
          "Proposer Name": "ಪ್ರಪೋಸರ್ ಹೆಸರು",
          "Life Assured Name": "ಜೀವನ ಭದ್ರವಾದವರ ಹೆಸರು",
          "Proposer date of birth": "ಪ್ರಸ್ತಾವಕರ ಜನ್ಮತಿಥಿ",
          "Registered Email Address": "ನೋಂದಾಯಿತ ಇಮೇಲ್ ವಿಳಾಸ",
          "Mobile Number": "ಮೊಬೈಲ್ ಸಂಖ್ಯೆ",
          Education: "ಶಿಕ್ಷಣ",
          Occupation: "ವೃತ್ತಿ",
          "Income (per annum)": "ಆದಾಯ (ಪ್ರತಿ ವರ್ಷ)",
          "Plan Name": "ಯೋಜನೆ ಹೆಸರು",
          "Life CoverSum assured": "ಜೀವನ ಕವರ್ಒಟ್ಟು ಖಾತರಿ",
          "Premium amount": "ಪ್ರೀಮಿಯಂ ಮೊತ್ತ",
          Frequency: "ಆವರ್ತನೆ",
          "Premium paying term": "ಪ್ರೀಮಿಯಂ ಪಾವತಿ ಅವಧಿ",
          "Policy term": "ಪಾಲಿಸಿ ಅವಧಿ",
          "Start Your Journey": "ನಿಮ್ಮ ಅರ್ಜಿ ಪ್ರಕ್ರಿಯೆಯನ್ನು ಪ್ರಾರಂಭಿಸಿ",
          "Reference No.": "ಉಲ್ಲೇಖ ಸಂಖ್ಯೆ",
          Language: "ಭಾಷೆ",
          "I Agree": "ನಾನು ಒಪ್ಪುತ್ತೇನೆ",
          Disagree: "ಅಸಮ್ಮತಿ",
          "Personal Details": "ವೈಯಕ್ತಿಕ ವಿವರಗಳು",
          "Policy Details": "ಪಾಲಿಸಿ ವಿವರಗಳು",
          "Video Consent": "ವೀಡಿಯೊ ಒಪ್ಪಿಗೆ",
          "Please record your video consent by clicking Start and clearly reading the text displayed on the screen. When you're done, click Stop to complete the process.":
            "ದಯವಿಟ್ಟು ಪ್ರಾರಂಭವನ್ನು ಕ್ಲಿಕ್ ಮಾಡಿ ಮತ್ತು ಪರದೆಯಲ್ಲಿ ತೋರಿಸಿರುವ ಪಠ್ಯವನ್ನು ಸ್ಪಷ್ಟವಾಗಿ ಓದುವುದರ ಮೂಲಕ ನಿಮ್ಮ ವೀಡಿಯೊ ಅನುಮತಿ ದಾಖಲೆ ಮಾಡಿ. ನೀವು ಮುಗಿದ ಮೇಲೆ, ಪ್ರಕ್ರಿಯೆಯನ್ನು ಪೂರ್ಣಗೊಳಿಸಲು ನಿಲ್ಲಿಸಿ ಕ್ಲಿಕ್ ಮಾಡಿ.",
          "Policy Details 1": "ನೀತಿ ವಿವರಗಳು ೧",
          "Policy Details 2": "ನೀತಿ ವಿವರಗಳು ೨",
          "Policy Details 3": "ನೀತಿ ವಿವರಗಳು ೩",
          "Policy Details 4": "ನೀತಿ ವಿವರಗಳು ೪",
          "Policy Details 5": "ನೀತಿ ವಿವರಗಳು ೫",
          "Policy Details 6": "ನೀತಿ ವಿವರಗಳು ೬",
          "Policy Details 7": "ನೀತಿ ವಿವರಗಳು ೭",
          "Policy Details 8": "ನೀತಿ ವಿವರಗಳು ೮",
          "Policy Details 9": "ನೀತಿ ವಿವರಗಳು ೯",
          "Policy Details 10": "ನೀತಿ ವಿವರಗಳು ೧೦",
          "Please wait while we verify your recording":
            "ನಿಮ್ಮ ರೆಕಾರ್ಡಿಂಗ್ ಪರಿಶೀಲಿಸುತ್ತಿರುವಾಗ ದಯವಿಟ್ಟು ಕಾಯಿರಿ.",
          Start: "ಪ್ರಾರಂಭ",
          Stop: "ನಿಲ್ಲಿಸು",
          "You have only one chance left to complete the verification.":
            "ದೃಢೀಕರಣವನ್ನು ಪೂರ್ಣಗೊಳಿಸಲು ನಿಮಗೆ ಇನ್ನೊಂದು ಮಾತ್ರ ಅವಕಾಶ ಉಳಿದಿದೆ.",
          "Max limit reached Please try after 24 hours":
            "ಗರಿಷ್ಠ ಮಿತಿ ತಲುಪಿದೆ. ದಯವಿಟ್ಟು 24 ಗಂಟೆಗಳ ನಂತರ ಪ್ರಯತ್ನಿಸಿ.",
          Close: "ಮುಚ್ಚಿ",
          "Incorrect Input details. Please reach out to our sales representative. [ERR002]": "ತಪ್ಪು ಇನ್ಪುಟ್ ವಿವರಗಳು. ದಯವಿಟ್ಟು ನಮ್ಮ ಮಾರಾಟ ಪ್ರತಿನಿಧಿಯನ್ನು ಸಂಪರ್ಕಿಸಿ. [ERR002]",
          "Application number": "ಅಪ್ಲಿಕೇಶನ್ ಸಂಖ್ಯೆ",
          "Thank you for your response. Our representative will contact you soon.":
            "ನಿಮ್ಮ ಪ್ರತಿಕ್ರಿಯೆಗೆ ಧನ್ಯವಾದಗಳು. ನಮ್ಮ ಪ್ರತಿನಿಧಿ ಶೀಘ್ರದಲ್ಲೇ ನಿಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸುತ್ತಾರೆ.",
          Cancel: "ರದ್ದುಮಾಡಿ",
          "Location permission is denied by user":
            "ಸ್ಥಳ ಅನುಮತಿಯನ್ನು ಬಳಕೆದಾರನು ತಿರಸ್ಕರಿಸಿದ್ದಾನೆ.",
          "Please allow location service from browser settings to continue.":
            "ದಯವಿಟ್ಟು ಬ್ರೌಸರ್ ಸೆಟ್ಟಿಂಗ್ಗಳಿಂದ ಸ್ಥಳ ಸೇವೆಯನ್ನು ಅನುಮತಿಸಿ.",
          "Error accessing location: User denied Geolocation. [ERR001]": "ಸ್ಥಳವನ್ನು ಪ್ರವೇಶಿಸುವಲ್ಲಿ ದೋಷ: ಬಳಕೆದಾರರು ಭೌಗೋಳಿಕ ಸ್ಥಳವನ್ನು ನಿರಾಕರಿಸಿದ್ದಾರೆ. [ERR001]",
          "Unable to access camera or microphone. Please ensure you have all the necessary permissions. [ERR004]": "ಕ್ಯಾಮೆರಾ ಅಥವಾ ಮೈಕ್ರೋಫೋನ್‌ ಪ್ರವೇಶ ಸಾಧ್ಯವಾಗುತ್ತಿಲ್ಲ. ದಯವಿಟ್ಟು ನೀವು ಎಲ್ಲಾ ಅಗತ್ಯ ಅನುಮತಿಗಳನ್ನು ನೀಡಿದ್ದೀರಾ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ. [ERR004]",
          "Record again": "ಮತ್ತೆ ದಾಖಲಿಸಿ",
          "The spoken text is inaccurate. Please try recording again.":
            "ಮಾತನಾಡಿದ ಪಠ್ಯವು ಸರಿಯಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ದಾಖಲಿಸಲು ಪ್ರಯತ್ನಿಸಿ.",
          "Return to homepage": "ಮನೆಪುಟಕ್ಕೆ ಹಿಂದಿರುಗಿ",
          "Your video consent was not successfully recorded. Please restart the process and try again.":
            "ನಿಮ್ಮ ವೀಡಿಯೊ ಒಪ್ಪಿಗೆಯನ್ನು ಯಶಸ್ವಿಯಾಗಿ ದಾಖಲಿಸಲಾಗಿಲ್ಲ. ದಯವಿಟ್ಟು ಪ್ರಕ್ರಿಯೆಯನ್ನು ಪುನಾರಂಭಿಸಿ ಮತ್ತು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
          "Your video consent could not be recorded due to a device change. Please try again.": "ಉಪಕರಣ ಬದಲಾವಣೆಯ ಕಾರಣದಿಂದಾಗಿ ನಿಮ್ಮ ವೀಡಿಯೊ ಅನುಮತಿ ದಾಖಲಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ. ದಯವಿಟ್ಟು ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
          videoVerificationMessage:
            "ವೀಡಿಯೋ ಪರಿಶೀಲನೆ ಪೂರ್ಣಗೊಳಿಸಿದಕ್ಕಾಗಿ ಧನ್ಯವಾದಗಳು <br className='hidden md:block' /> ಅರ್ಜಿ ಸಂಖ್ಯೆ {{appNo}}",
          customerCareMessage:
            'ನಿಮ್ಮ ನೀತಿ ಡಾಕ್ಯುಮೆಂಟ್‌ಗಳನ್ನು ಜಾರಿಯಾದ ನಂತರ ಷರತ್ತುಗಳು ಮತ್ತು ನಿಯಮಗಳನ್ನು ಪರಿಶೀಲಿಸಿ <br className="hidden md:block" /> 30-ದಿನಗಳ ಉಚಿತ ವೀಕ್ಷಣೆ ಅವಧಿಯಲ್ಲಿ ಮತ್ತು ಯಾವುದೇ ಚಿಂತೆಗಳು ಇದ್ದರೆ ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ।<br className="hidden md:block" /> ನೀವು ನಮಗೆ 18002660 ಗೆ ಸಂಪರ್ಕಿಸಬಹುದು ಅಥವಾ ನಮ್ಮ ವೆಬ್‌ಸೈಟ್/ಮೊಬೈಲ್ ಅಪ್ಲಿಕೇಶನ್‌ಗೆ ಭೇಟಿ ನೀಡಬಹುದು.',
          "Please wait while we verify your recording.":
            "ದಯವಿಟ್ಟು ನೀವು ರೆಕಾರ್ಡಿಂಗ್ ಪರಿಶೀಲಿಸುತ್ತಿರುವವರೆಗೆ ನಿರೀಕ್ಷಿಸಿ.",
          timeRemaining: "ಸಮಯ ಉಳಿದಿದೆ {{timer}} ಸೆಕೆಂಡು",
          "Please hold on while we verify your video":
            "ದಯವಿಟ್ಟು ಕೆಲವು ಸಮಯ ಕಾಯಿರಿ, ನಾವು ನಿಮ್ಮ ವಿಡಿಯೋವನ್ನು ಪರಿಶೀಲಿಸುತ್ತಿದ್ದೇವೆ",
          "Face detected": "ಮುಖವನ್ನು ಕಂಡುಹಿಡಿದಿದೆ",
          "Multiple faces detected. Please make sure only one person is in view!":
            "ಬಹುಮೂಹಗಳನ್ನು ಕಂಡುಹಿಡಿದಿದೆ. ದಯವಿಟ್ಟು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ, ಒಬ್ಬೆಬ್ಬರೇ ದೃಷ್ಯಮಾನವಾಗಿದೆ!",
          "Face Match Unsuccessful!": "ಮುಖ ನೇರಸ್ಪಂದನ ವಿಫಲವಾಗಿದೆ!",
          "Make sure a real person is in view and looking towards camera in a well-lit area!":
            "ನಿಜವಾದ ವ್ಯಕ್ತಿಯೊಬ್ಬರು ದೃಷ್ಟಿಯಲ್ಲಿದ್ದಾರೆ ಮತ್ತು ಉತ್ತಮ ಬೆಳಕಿನಲ್ಲಿರುವ ಪ್ರದೇಶದಲ್ಲಿ ಕ್ಯಾಮೆರಾದ ಕಡೆಗೆ ನೋಡುತ್ತಿದ್ದಾರೆ ಎಂದು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ!",
          "No face detected. Please ensure your face is clearly visible.":
            "ಯಾವುದೇ ಮುಖ ಕಂಡುಹಿಡಿಯಲಾಗಿಲ್ಲ. ದಯವಿಟ್ಟು ಖಚಿತಪಡಿಸಿಕೊಳ್ಳಿ, ನಿಮ್ಮ ಮುಖ ಸ್ಪಷ್ಟವಾಗಿ ದೃಷ್ಯಮಾನವಾಗಿದೆ.",
          "You don't have camera permissions, Please give permissions manually":
            "ನಿಮ್ಮ ಬಳಿ ಕ್ಯಾಮೆರಾ ಅನುಮತಿಗಳು ಇಲ್ಲ, ದಯವಿಟ್ಟು ಅನುಮತಿಗಳನ್ನು ಕೈಯಿಂದ ನೀಡಿ",
          "Meeting connection failed": "ಮೀಟಿಂಗ್ ಸಂಪರ್ಕ ವಿಫಲವಾಗಿದೆ",
          "Meeting connection disconnected abruptly":
            "ಮೀಟಿಂಗ್ ಸಂಪರ್ಕ ತಕ್ಷಣವೇ ತುಂಡಾಗಿದೆ",
          'I hereby give my consent and authorize ICICI Prudential Life Insurance Company by clicking on "Start Your Journey" button to use my photo and video footage for verification purpose and to share my photo and video footage provided herein on confidential basis with ICICI group and/or third-party agencies':
            'ನಾನು ಇಲ್ಲಿ ನನ್ನ ಒಪ್ಪಿಗೆಯನ್ನು ನೀಡುತ್ತೇನೆ ಮತ್ತು ICICI ಪ್ರುಡೆನ್ಷಿಯಲ್ ಲೈಫ್ ಇನ್ಶುರನ್ಸ್ ಕಂಪನಿಯನ್ನು "ನಿಮ್ಮ ಅರ್ಜಿ ಪ್ರಕ್ರಿಯೆಯನ್ನು ಪ್ರಾರಂಭಿಸಿ" ಬಟನ್ ಕ್ಲಿಕ್ ಮಾಡುವ ಮೂಲಕ ನನ್ನ ಫೋಟೋ ಮತ್ತು ವೀಡಿಯೊ ದೃಶ್ಯವನ್ನು ಪರಿಶೀಲನೆಗಾಗಿ ಬಳಸಲು ಮತ್ತು ICICI ಗುಂಪು ಮತ್ತು/ಅಥವಾ ತೃತೀಯ-ಪಕ್ಷ ಸಂಸ್ಥೆಗಳೊಂದಿಗೆ ಗೌಪ್ಯತೆಯಿಂದ ಹಂಚಿಕೊಳ್ಳಲು ಅನುಮತಿಸುತ್ತೇನೆ.',
          "Life assured gender": "ವಿಮಾ ಪಡೆದ ವ್ಯಕ್ತಿಯ ಲಿಂಗ",
          "Repeat Details": "ವಿವರಗಳನ್ನು ಪುನರಾವರ್ತಿಸಿ",
          "Premium Amount(Inclusive of all applicable taxes)":
            "ಪ್ರೀಮಿಯಂ ಮೊತ್ತ (ಎಲ್ಲಾ ಅನ್ವಯಿಸುವ ತೆರಿಗೆಗಳನ್ನು ಒಳಗೊಂಡಿದೆ)",
          "Total Premium Amount(Inclusive of all applicable taxes)":
            "ಒಟ್ಟು ಪ್ರೀಮಿಯಂ ಮೊತ್ತ (ಎಲ್ಲಾ ಅನ್ವಯಿಸುವ ತೆರಿಗೆಗಳನ್ನು ಒಳಗೊಂಡಿದೆ)",
          "Unable to fetch device details, Please try using another device.":
            "ಸಾಧನ ವಿವರಗಳನ್ನು ಪಡೆಯಲು ವಿಫಲ, ದಯವಿಟ್ಟು ಇನ್ನೊಂದು ಸಾಧನವನ್ನು ಬಳಸಲು ಪ್ರಯತ್ನಿಸಿ.",
          "Starting Your Journey...":
            "ನಿಮ್ಮ ಅರ್ಜಿಯ ಪ್ರಕ್ರಿಯೆ ಆರಂಭಗೊಳ್ಳುತ್ತಿದೆ...",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR099]": "ಅಯ್ಯೋ! ಕೆಲವೊಂದು ದೋಷ ಸಂಭವಿಸಿದೆ. ದಯವಿಟ್ಟು ನಮ್ಮ ಮಾರಾಟ ಪ್ರತಿನಿಧಿಯನ್ನು ಸಂಪರ್ಕಿಸಿ ಅಥವಾ ನಮಗೆ vidassure@iciciprulife.com ಗೆ ಬರೆಯಿರಿ. [ERR099]",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR003]": "ಅಯ್ಯೋ! ಕೆಲವೊಂದು ದೋಷ ಸಂಭವಿಸಿದೆ. ದಯವಿಟ್ಟು ನಮ್ಮ ಮಾರಾಟ ಪ್ರತಿನಿಧಿಯನ್ನು ಸಂಪರ್ಕಿಸಿ ಅಥವಾ ನಮಗೆ vidassure@iciciprulife.com ಗೆ ಬರೆಯಿರಿ. [ERR003]",
          "Our services are temporarily unavailable. Please try again shortly.": "ನಮ್ಮ ಸೇವೆಗಳು ತಾತ್ಕಾಲಿಕವಾಗಿ ಲಭ್ಯವಿಲ್ಲ. ದಯವಿಟ್ಟು ಸ್ವಲ್ಪ ಹೊತ್ತಿನಲ್ಲಿ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.",
          "Please provide a reason for disagreeing": "ಅಸಹಮತಿ ಕಾರಣ ದಾಖಲಿಸಿ",
          "Reason should be less than 100 characters and more than 20 characters": "ಕಾರಣವು 100 ಅಕ್ಷರಗಳಿಗಿಂತ ಕಡಿಮೆ ಮತ್ತು 20 ಅಕ್ಷರಗಳಿಗಿಂತ ಹೆಚ್ಚಿರಬೇಕು.",
          "Reason should only contain letters and numbers": "ಕಾರಣದಲ್ಲಿ ಕೇವಲ ಅಕ್ಷರಗಳು ಮತ್ತು ಸಂಖ್ಯೆಗಳು ಮಾತ್ರ ಇರಬೇಕು",
          "Enter your reason for disagreeing here...": "ನಿಮ್ಮ ಭಿನ್ನಾಭಿಪ್ರಾಯಕ್ಕೆ ಕಾರಣವನ್ನು ಇಲ್ಲಿ ನಮೂದಿಸಿ...",
          "Submit for Validation": "ಮಾನ್ಯತೆಗಾಗಿ ಸಲ್ಲಿಸಿ",
          "Your journey is about to expire in one minute. Please complete any pending actions.": "ನಿಮ್ಮ ಪ್ರಯಾಣ ಇನ್ನೊಂದು ನಿಮಿಷದಲ್ಲಿ ಮುಗಿಯಲಿದೆ. ದಯವಿಟ್ಟು ಬಾಕಿ ಇರುವ ಕೆಲಸಗಳನ್ನು ಪೂರ್ಣಗೊಳಿಸಿ."

        },
      },
      ta: {
        translation: {
          "Proposer Name": "முன்மொழிபவர் பெயர்",
          "Life Assured Name": "வாழ்நாள் காப்பீட்டாளரின் பெயர்",
          "Proposer date of birth": "முன்மொழிப்பவரின் பிறந்த தேதி",
          "Registered Email Address": "பதிவுசெய்யப்பட்ட மின்னஞ்சல் முகவரி",
          "Mobile Number": "மொபைல் எண்",
          Education: "கல்வி",
          Occupation: "தொழில்",
          "Income (per annum)": "வருமானம் (வருடத்திற்கு)",
          "Plan Name": "திட்டத்தின் பெயர்",
          "Life CoverSum assured": "வாழ்க்கை கவர்மொத்த உறுதி",
          "Premium amount": "கட்டணம் அளவு",
          Frequency: "அடிக்கடி",
          "Premium paying term": "கட்டணம் செலுத்தும் காலம்",
          "Policy term": "காப்பீட்டு காலம்",
          "Start Your Journey": "உங்கள் விண்ணப்ப செயலையை தொடங்குங்கள்",
          "Reference No.": "குறிப்பு எண்",
          Language: "மொழி",
          "I Agree": "நான் ஒப்புக்கொள்கிறேன்",
          Disagree: "எதிர்ப்பு",
          "Personal Details": "தனிப்பட்ட விவரங்கள்",
          "Policy Details": "காப்பீட்டு விவரங்கள்",
          "Video Consent": "வீடியோ ஒப்புதல்",
          "Please record your video consent by clicking Start and clearly reading the text displayed on the screen. When you're done, click Stop to complete the process.":
            "தயவுசெய்து தொடக்கத்தை கிளிக் செய்து திரையில் காணப்படும் உரையை தெளிவாகப் படித்து உங்கள் வீடியோ ஒப்புதலை பதிவு செய்யவும். முடித்துவிட்டால், நிறுத்தத்தை கிளிக் செய்து செயல்முறையை முடிக்கவும்.",
          "Policy Details 1": "காப்பீட்டு விவரங்கள் ௧",
          "Policy Details 2": "காப்பீட்டு விவரங்கள் ௨",
          "Policy Details 3": "காப்பீட்டு விவரங்கள் ௩",
          "Policy Details 4": "காப்பீட்டு விவரங்கள் ௪",
          "Policy Details 5": "காப்பீட்டு விவரங்கள் ௫",
          "Policy Details 6": "காப்பீட்டு விவரங்கள் ௬",
          "Policy Details 7": "காப்பீட்டு விவரங்கள் ௭",
          "Policy Details 8": "காப்பீட்டு விவரங்கள் ௮",
          "Policy Details 9": "காப்பீட்டு விவரங்கள் ௯",
          "Policy Details 10": "காப்பீட்டு விவரங்கள் ௧௦",
          "Please wait while we verify your recording":
            "உங்கள் பதிவு சரிபார்க்கப்படும் வரை காத்திருக்கவும்.",
          Start: "தொடங்கு",
          Stop: "நிறுத்து",
          "You have only one chance left to complete the verification.":
            "உறுதிப்படுத்தலை முடிக்க உங்களுக்கு இன்னும் ஒரு வாய்ப்பே உள்ளது.",
          "Max limit reached Please try after 24 hours":
            "அதிகபட்ச வரம்பை அடைந்தது. 24 மணி நேரத்திற்கு பிறகு முயற்சிக்கவும்.",
          Close: "மூடு",
          "Incorrect Input details. Please reach out to our sales representative. [ERR002]": "தவறான உள்ளீட்டு விவரங்கள். தயவுசெய்து எங்கள் விற்பனை பிரதிநிதியை தொடர்பு கொள்ளுங்கள். [ERR002]",
          "Application number": "விண்ணப்ப எண்",
          "Thank you for your response. Our representative will contact you soon.":
            "உங்கள் பதிலுக்கு நன்றி. எங்கள் பிரதிநிதி விரைவில் உங்களை தொடர்புகொள்வார்.",
          Cancel: "ரத்துசெய்",
          "Location permission is denied by user":
            "இருப்பிட அனுமதி பயனர் மறுத்துவிட்டார்.",
          "Please allow location service from browser settings to continue.":
            "தொடரவும், உலாவி அமைப்புகளிலிருந்து இடம் சேவையை அனுமதிக்கவும்.",
          "Error accessing location: User denied Geolocation. [ERR001]": "இருப்பிடம் அணுகும் போது பிழை: பயனர் புவியிடங்காட்டியை நிராகரித்தார். [ERR001]",
          "Unable to access camera or microphone. Please ensure you have all the necessary permissions. [ERR004]": "கேமரா அல்லது மைக்ரோஃபோனைப் அணுக முடியவில்லை. தேவையான அனைத்து அனுமதிகளும் உள்ளனவா என்பதை உறுதிப்படுத்தவும். [ERR004]",
          "Record again": "மீண்டும் பதிவு செய்க",
          "The spoken text is inaccurate. Please try recording again.":
            "பேசப்பட்ட உரை தவறாக உள்ளது. தயவுசெய்து மீண்டும் பதிவு செய்து முயற்சிக்கவும்.",
          "Return to homepage": "முகப்புப் பக்கத்திற்கு திரும்பவும்",
          "Your video consent was not successfully recorded. Please restart the process and try again.":
            "உங்கள் வீடியோ ஒப்புதல் வெற்றிகரமாக பதிவு செய்யப்படவில்லை. தயவுசெய்து செயல்முறையை மீண்டும் தொடங்கி முயற்சிக்கவும்.",
          "Your video consent could not be recorded due to a device change. Please try again.": "சாதன மாற்றம் காரணமாக உங்கள் வீடியோ ஒப்புதல் பதிவு செய்ய முடியவில்லை. தயவுசெய்து மீண்டும் முயற்சிக்கவும்.",
          videoVerificationMessage:
            "வீடியோ சரிபார்ப்பை முடித்ததற்காக நன்றி <br className='hidden md:block' /> விண்ணப்ப எண் {{appNo}}",
          customerCareMessage:
            'உங்கள் காப்பீட்டு ஆவணங்களை வெளியீட்டிற்குப் பிறகு விதிமுறைகள் மற்றும் நிபந்தனைகளைச் சரிபார்க்கவும் <br className="hidden md:block" /> 30 நாள் இலவச பார்வை காலத்தின்போது, மேலும் ஏதேனும் கவலை இருப்பின் எங்களைத் தொடர்பு கொள்ளவும்.<br className="hidden md:block" /> நீங்கள் எங்களை 18002660 என்ற எண்ணில் தொடர்பு கொள்ளலாம் அல்லது எங்கள் வலைத்தளம்/மொபைல் பயன்பாட்டைப் பார்வையிடலாம்.',
          "Please wait while we verify your recording.":
            "உங்கள் பதிவு சரிபார்க்கப்படும் வரை காத்திருக்கவும்.",
          timeRemaining: "மொத்த நேரம் கையிருப்பு {{timer}} விநாடிகள்",
          "Please hold on while we verify your video":
            "தயவுசெய்து கொஞ்சம் நேரம் காத்திருங்கள், நாங்கள் உங்கள் வீடியோகை சரிபார்க்கின்றோம்",
          "Face detected": "முகம் கண்டறியப்பட்டது",
          "Multiple faces detected. Please make sure only one person is in view!":
            "பல முகங்கள் கண்டறியப்பட்டன. தயவுசெய்து உறுதி செய்யுங்கள், ஒரே ஒரு நபர் மட்டுமே காட்சி அளிக்கிறார்!",
          "Face Match Unsuccessful!": "முகம் பொருந்தவில்லை!",
          "Make sure a real person is in view and looking towards camera in a well-lit area!":
            "நன்கு வெளிச்சம் உள்ள இடத்தில் ஒரு உண்மையான நபர் பார்வையில் இருப்பதையும், கேமராவை நோக்கிப் பார்ப்பதையும் உறுதிப்படுத்திக் கொள்ளுங்கள்!",
          "No face detected. Please ensure your face is clearly visible.":
            "எந்த முகமும் கண்டறியப்படவில்லை. தயவுசெய்து உங்கள் முகம் தெளிவாக காட்சியளிக்கின்றது என்பதை உறுதி செய்யுங்கள்.",
          "You don't have camera permissions, Please give permissions manually":
            "உங்களிடம் கேமரா அனுமதிகள் இல்லை, தயவுசெய்து கையேடு அனுமதிகளை வழங்கவும்",
          "Meeting connection failed": "மீட்டிங் இணைப்பு தோல்வியடைந்தது",
          "Meeting connection disconnected abruptly":
            "மீட்டிங் இணைப்பு திடீரென துண்டிக்கப்பட்டது",
          'I hereby give my consent and authorize ICICI Prudential Life Insurance Company by clicking on "Start Your Journey" button to use my photo and video footage for verification purpose and to share my photo and video footage provided herein on confidential basis with ICICI group and/or third-party agencies':
            'நான் இங்கு எனது ஒப்புதலை வழங்குகிறேன் மற்றும் ICICI ப்ருடென்ஷியல் லைஃப் இன்சூரன்ஸ் கம்பெனியை "உங்கள் விண்ணப்ப செயலையை தொடங்குங்கள்" பட்டனை கிளிக் செய்வதன் மூலம் என் புகைப்படம் மற்றும் வீடியோ காட்சிகளை சரிபார்ப்பு நோக்கத்திற்காகப் பயன்படுத்த அனுமதிக்கிறேன் மற்றும் ICICI குழு மற்றும்/அல்லது மூன்றாம் தரப்பு முகமைகளுடன் ரகசியமாக பகிர அனுமதிக்கிறேன்.',
          "Life assured gender": "காப்பீடு செய்யப்பட்டவரின் பாலினம்",
          "Repeat Details": "விவரங்களை மீண்டும் உள்ளிடுங்கள்",
          "Premium Amount(Inclusive of all applicable taxes)":
            "பிரீமியம் தொகை (அனைத்து பொருந்தும் வரிகளுடன்)",
          "Total Premium Amount(Inclusive of all applicable taxes)":
            "மொத்த பிரீமியம் தொகை (அனைத்து பொருந்தும் வரிகளுடன்)",
          "Unable to fetch device details, Please try using another device.":
            "சாதனம் விவரங்களைப் பெற முடியவில்லை, தயவுசெய்து மற்றொரு சாதனத்தைப் பயன்படுத்த முயற்சிக்கவும்.",
          "Starting Your Journey...":
            "உங்கள் விண்ணப்ப செயல்முறை தொடங்குகிறது...",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR099]": "ஓஹோ! சில பிழைகள் ஏற்பட்டுவிட்டது. தயவுசெய்து எங்கள் விற்பனை பிரதிநிதியை தொடர்பு கொள்ளவும் அல்லது எங்களுக்கு vidassure@iciciprulife.com இல் எழுதவும். [ERR099]",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR003]": "ஓஹோ! சில பிழைகள் ஏற்பட்டுவிட்டது. தயவுசெய்து எங்கள் விற்பனை பிரதிநிதியை தொடர்பு கொள்ளவும் அல்லது எங்களுக்கு vidassure@iciciprulife.com இல் எழுதவும். [ERR003]",
          "Our services are temporarily unavailable. Please try again shortly.": "எங்கள் சேவைகள் தற்காலிகமாக கிடைக்கவில்லை. தயவுசெய்து சிறிது நேரம் கழித்து மீண்டும் முயற்சிக்கவும்.",
          "Please provide a reason for disagreeing": "அஸம்மதி காரணத்தை கொடுக்கவும்",
          "Reason should be less than 100 characters and more than 20 characters": "காரணம் 100 எழுத்துகளுக்குக் குறைவாகவும் 20 எழுத்துகளுக்கு மேல் இருக்க வேண்டும்.",
          "Reason should only contain letters and numbers": "காரணத்தில் எழுத்துகள் மற்றும் எண்கள் மட்டுமே இருக்க வேண்டும்",
          "Enter your reason for disagreeing here...": "உங்கள் கருத்து வேறுபாட்டிற்கான காரணத்தை இங்கே உள்ளிடவும்...",
          "Submit for Validation": "சரிபார்ப்புக்காக சமர்ப்பிக்கவும்",
          "Your journey is about to expire in one minute. Please complete any pending actions.": "உங்கள் பயணம் ஒரு நிமிடத்தில் முடிவடைய உள்ளது. தயவுசெய்து ஏதேனும் நிலுவையில் உள்ள செயல்களை முடிக்கவும்."

        },
      },
      te: {
        translation: {
          "Proposer Name": "ప్రతిపాదకుని పేరు",
          "Life Assured Name": "జీవిత బీమా పొందిన వ్యక్తి పేరు",
          "Proposer date of birth": "ప్రతిపాదకుడి జన్మ తేదీ",
          "Registered Email Address": "నమోదైన ఈమెయిల్ చిరునామా",
          "Mobile Number": "మొబైల్ నంబర్",
          Education: "విద్య",
          Occupation: "వృత్తి",
          "Income (per annum)": "ఆదాయం (ప్రతి సంవత్సరం)",
          "Plan Name": "ప్రణాళిక పేరు",
          "Life CoverSum assured": "జీవన కవర్మొత్తం హామీ",
          "Premium amount": "ప్రీమియం మొత్తం",
          Frequency: "పునరావృతం",
          "Premium paying term": "ప్రీమియం చెల్లింపు కాలం",
          "Policy term": "పాలసీ కాలం",
          "Start Your Journey": "మీ దరఖాస్తు ప్రక్రియను ప్రారంభించండి",
          "Reference No.": "సూచన సంఖ్య",
          Language: "భాష",
          "I Agree": "నేను అంగీకరిస్తున్నాను",
          Disagree: "అసమ్మతి",
          "Personal Details": "వ్యక్తిగత వివరాలు",
          "Policy Details": "పాలసీ వివరాలు",
          "Video Consent": "వీడియో సమ్మతి",
          "Please record your video consent by clicking Start and clearly reading the text displayed on the screen. When you're done, click Stop to complete the process.":
            "దయచేసి ప్రారంభం పై క్లిక్ చేసి, స్క్రీన్‌లో చూపబడిన పాఠాన్ని స్పష్టంగా చదవడం ద్వారా మీ వీడియో సమ్మతి రికార్డు చేయండి. మీరు పూర్తి చేసినప్పుడు, ప్రక్రియను పూర్తి చేయడానికి నిలిపి పై క్లిక్ చేయండి.",
          "Policy Details 1": "పాలసీ వివరాలు ౧",
          "Policy Details 2": "పాలసీ వివరాలు ౨",
          "Policy Details 3": "పాలసీ వివరాలు ౩",
          "Policy Details 4": "పాలసీ వివరాలు ౪",
          "Policy Details 5": "పాలసీ వివరాలు ౫",
          "Policy Details 6": "పాలసీ వివరాలు ౬",
          "Policy Details 7": "పాలసీ వివరాలు ౭",
          "Policy Details 8": "పాలసీ వివరాలు ౮",
          "Policy Details 9": "పాలసీ వివరాలు ౯",
          "Policy Details 10": "పాలసీ వివరాలు ౧౦",
          "Please wait while we verify your recording":
            "మీ రికార్డింగ్‌ను నిర్ధారించే వరకు దయచేసి వేచి ఉండండి.",
          Start: "ప్రారంభం",
          Stop: "ఆపివేయి",
          "You have only one chance left to complete the verification.":
            "ధృవీకరణను పూర్తి చేయడానికి మీకు మరో ఒక్క అవకాశం మాత్రమే మిగిలి ఉంది.",
          "Max limit reached Please try after 24 hours":
            "గరిష్ట పరిమితిని చేరుకున్నారు. దయచేసి 24 గంటల తర్వాత ప్రయత్నించండి.",
          Close: "మూసివేయి",
          "Incorrect Input details. Please reach out to our sales representative. [ERR002]": "తప్పు ఇన్‌పుట్ వివరాలు. దయచేసి మా అమ్మకాల ప్రతినిధిని సంప్రదించండి. [ERR002]",
          "Application number": "దరఖాస్తు సంఖ్య",
          "Thank you for your response. Our representative will contact you soon.":
            "మీ ప్రతిస్పందనకు ధన్యవాదాలు. మా ప్రతినిధి త్వరలోనే మీను సంప్రదిస్తారు.",
          Cancel: "రద్దుచేయి",
          "Location permission is denied by user":
            "లొకేషన్ అనుమతిని వాడుకరి తిరస్కరించారు.",
          "Please allow location service from browser settings to continue.":
            "దయచేసి బ్రౌజర్ సెట్టింగుల నుండి లొకేషన్ సేవను అనుమతించండి.",
          "Error accessing location: User denied Geolocation. [ERR001]": "స్థానాన్ని ప్రాప్తించడంలో లోపం: వినియోగదారు జియోలొకేషన్‌ను తిరస్కరించారు. [ERR001]",
          "Unable to access camera or microphone. Please ensure you have all the necessary permissions. [ERR004]": "కెమెరా లేదా మైక్రోఫోన్‌కి యాక్సెస్ లభించడం లేదు. దయచేసి అవసరమైన అనుమతులు ఇచ్చి ఉన్నాయో లేదో నిర్ధారించుకోండి. [ERR004]",
          "Record again": "మళ్లీ రికార్డ్ చేయండి.",
          "The spoken text is inaccurate. Please try recording again.":
            "చెప్పబడిన పాఠం సరిగా లేదు. దయచేసి మళ్లీ రికార్డింగ్ చేయడానికి ప్రయత్నించండి.",
          "Return to homepage": "హోంపేజీకి తిరిగి వెళ్లండి.",
          "Your video consent was not successfully recorded. Please restart the process and try again.":
            "మీ వీడియో ఒప్పందం విజయవంతంగా రికార్డు కాలేదు. దయచేసి ప్రక్రియను మళ్లీ ప్రారంభించి ప్రయత్నించండి.",
          "Your video consent could not be recorded due to a device change. Please try again.": "పరికరం మారిన కారణంగా మీ వీడియో అనుమతి నమోదయ్యలేదు. దయచేసి మళ్లీ ప్రయత్నించండి.",
          videoVerificationMessage:
            "వీడియో నిర్ధారణ పూర్తి చేసినందుకు ధన్యవాదాలు <br className='hidden md:block' /> దరఖాస్తు సంఖ్య {{appNo}}",
          customerCareMessage:
            'మీ పాలసీ పత్రాలను జారీ అయిన తర్వాత నిబంధనలు మరియు షరతులను తనిఖీ చేయండి <br className="hidden md:block" /> 30-రోజుల ఉచిత వీక్షణ వ్యవధిలో మరియు మీకు ఏవైనా సందేహాలు ఉంటే మమ్మల్ని సంప్రదించండి.<br className="hidden md:block" /> మీరు మమ్మల్ని 18002660 నంబర్లో సంప్రదించవచ్చు లేదా మా వెబ్‌సైట్/మొబైల్ యాప్‌ను సందర్శించవచ్చు.',
          "Please wait while we verify your recording.":
            "దయచేసి మీ రికార్డింగ్‌ను మనం ధృవీకరిస్తున్నప్పటి వరకు వేచి ఉండండి.",
          timeRemaining: "సమయం మిగిలి ఉంది {{timer}} సెకన్లు",
          "Please hold on while we verify your video":
            "దయచేసి కొంతసేపు ఎదురుచూసి ఉండండి, మేము మీ వీడియోని ధృవీకరిస్తున్నాము",
          "Face detected": "ముఖం గుర్తించబడింది",
          "Multiple faces detected. Please make sure only one person is in view!":
            "బహుళ ముఖాలు గుర్తించబడ్డాయి. దయచేసి ఒకే ఒక వ్యక్తి మాత్రమే కనిపిస్తున్నారని నిర్ధారించుకోండి!",
          "Face Match Unsuccessful!": "ముఖం సరిపోలడం విఫలమైంది!",
          "Make sure a real person is in view and looking towards camera in a well-lit area!":
            "నిజమైన వ్యక్తి దృష్టిలో ఉండి, బాగా వెలుతురు ఉన్న ప్రదేశంలో కెమెరా వైపు చూస్తున్నారని నిర్ధారించుకోండి!",
          "No face detected. Please ensure your face is clearly visible.":
            "ముఖం గుర్తించబడలేదు. దయచేసి మీ ముఖం స్పష్టంగా కనిపిస్తున్నట్లు నిర్ధారించుకోండి.",
          "You don't have camera permissions, Please give permissions manually":
            "మీకు కెమెరా అనుమతులు లేవు, దయచేసి అనుమతులను చేతితో ఇవ్వండి",
          "Meeting connection failed": "మీటింగ్ కనెక్షన్ విఫలమైంది",
          "Meeting connection disconnected abruptly":
            "మీటింగ్ కనెక్షన్ అకస్మాత్తుగా తెగిపోయింది",
          'I hereby give my consent and authorize ICICI Prudential Life Insurance Company by clicking on "Start Your Journey" button to use my photo and video footage for verification purpose and to share my photo and video footage provided herein on confidential basis with ICICI group and/or third-party agencies':
            'నేను ఇక్కడ నా సమ్మతిని ఇస్తున్నాను మరియు ICICI ప్రుడెన్షియల్ లైఫ్ ఇన్సూరెన్స్ కంపెనీని "మీ దరఖాస్తు ప్రక్రియను ప్రారంభించండి" బటన్‌పై క్లిక్ చేయడం ద్వారా నా ఫోటో మరియు వీడియో ఫుటేజీని ధృవీకరణ ప్రయోజనానికి ఉపయోగించడానికి మరియు ICICI గ్రూప్ మరియు/లేదా మూడవ పక్ష సంస్థలతో గోప్యంగా భాగస్వామ్యం చేసేందుకు అనుమతిస్తున్నాను.',
          "Life assured gender": "జీవిత బీమా పొందిన వ్యక్తి లింగం",
          "Repeat Details": "వివరాలను పునరావృతం చేయండి",
          "Premium Amount(Inclusive of all applicable taxes)":
            "ప్రీమియం మొత్తం (అన్ని వర్తించే పన్నులతో సహా)",
          "Total Premium Amount(Inclusive of all applicable taxes)":
            "మొత్తం ప్రీమియం మొత్తం (అన్ని వర్తించే పన్నులతో సహా)",
          "Unable to fetch device details, Please try using another device.":
            "పరికర వివరాలను పొందడానికి విఫలమైనది, దయచేసి మరొక పరికరాన్ని ఉపయోగించడానికి ప్రయత్నించండి.",
          "Starting Your Journey...": "మీ అభ్యర్థన ప్రక్రియ ప్రారంభమవుతోంది...",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR099]": "అయ్యో! కొన్ని లోపాలు సంభవించాయి. దయచేసి మా విక్రయ ప్రతినిధిని సంప్రదించండి లేదా మాకు vidassure@iciciprulife.com కు రాయండి. [ERR099]",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR003]": "అయ్యో! కొన్ని లోపాలు సంభవించాయి. దయచేసి మా విక్రయ ప్రతినిధిని సంప్రదించండి లేదా మాకు vidassure@iciciprulife.com కు రాయండి. [ERR003]",
          "Our services are temporarily unavailable. Please try again shortly.": "మా సేవలు తాత్కాలికంగా అందుబాటులో లేవు. దయచేసి కొద్దిసేపటి తర్వాత మళ్లీ ప్రయత్నించండి.",
          "Please provide a reason for disagreeing": "అసమ్మతి కారణం ఇస్తున్నారు",
          "Reason should be less than 100 characters and more than 20 characters": "కారణం 100 అక్షరాల కంటే తక్కువ మరియు 20 అక్షరాల కంటే ఎక్కువ ఉండాలి.",
          "Reason should only contain letters and numbers": "కారణంలో అక్షరాలు మరియు సంఖ్యలు మాత్రమే ఉండాలి",
          "Enter your reason for disagreeing here...": "మీరు విభేదించడానికి గల కారణాన్ని ఇక్కడ నమోదు చేయండి...",
          "Submit for Validation": "ధృవీకరణ కోసం సమర్పించండి",
          "Your journey is about to expire in one minute. Please complete any pending actions.": "మీ ప్రయాణం ఒక నిమిషంలో ముగియనుంది. దయచేసి ఎలాంటి పెండింగ్ చర్యలైనా పూర్తిచేయండి."

        },
      },
      ml: {
        translation: {
          "Proposer Name": "നിർദേശകന്റെ പേര്",
          "Life Assured Name": "ജീവിത ബീമിതരുടെ പേര്",
          "Proposer date of birth": "പ്രമേയകന്റെ ജനനത്തിയതി",
          "Registered Email Address": "രജിസ്റ്റർ ചെയ്ത ഇമെയിൽ വിലാസം",
          "Mobile Number": "മൊബൈൽ നമ്പർ",
          Education: "വിദ്യാഭ്യാസം",
          Occupation: "തൊഴിൽ",
          "Income (per annum)": "വരുമാനം (പ്രതിവർഷം)",
          "Plan Name": "പദ്ധതിയുടെ പേര്",
          "Life CoverSum assured": "ജീവിത കവർമൊത്തം ഉറപ്പ്",
          "Premium amount": "പ്രീമിയം തുക",
          Frequency: "ആവൃത്തി",
          "Premium paying term": "പ്രീമിയം അടയ്ക്കുന്ന കാലാവധി",
          "Policy term": "പോലിസി കാലാവധി",
          "Start Your Journey": "നിങ്ങളുടെ അപേക്ഷ പ്രക്രിയ ആരംഭിക്കുക",
          "Reference No.": "അടിസ്ഥാന നമ്പർ",
          Language: "ഭാഷ",
          "I Agree": "ഞാൻ സമ്മതിക്കുന്നു",
          Disagree: "അസമ്മതി",
          "Personal Details": "വ്യക്തിഗത വിവരങ്ങൾ",
          "Policy Details": "പോളിസി വിവരങ്ങൾ",
          "Video Consent": "വീഡിയോ സമ്മതം",
          "Please record your video consent by clicking Start and clearly reading the text displayed on the screen. When you're done, click Stop to complete the process.":
            "ദയവായി സ്റ്റാർട്ടിൽ ക്ലിക്ക് ചെയ്ത് സ്ക്രീനിൽ പ്രദർശിപ്പിച്ച ടെക്സ്റ്റ് വ്യക്തമായി വായിച്ച് നിങ്ങളുടെ വീഡിയോ സമ്മതി റെക്കോർഡ് ചെയ്യുക. നിങ്ങൾ പൂർത്തിയാക്കിയ ശേഷം പ്രക്രിയ പൂർത്തിയാക്കാൻ സ്റ്റോപ്പിൽ ക്ലിക്ക് ചെയ്യുക.",
          "Policy Details 1": "പോളിസി വിശദാംശങ്ങൾ ൧",
          "Policy Details 2": "പോളിസി വിശദാംശങ്ങൾ ൨",
          "Policy Details 3": "പോളിസി വിശദാംശങ്ങൾ ൩",
          "Policy Details 4": "പോളിസി വിശദാംശങ്ങൾ ൪",
          "Policy Details 5": "പോളിസി വിശദാംശങ്ങൾ ൫",
          "Policy Details 6": "പോളിസി വിശദാംശങ്ങൾ ൬",
          "Policy Details 7": "പോളിസി വിശദാംശങ്ങൾ ൭",
          "Policy Details 8": "പോളിസി വിശദാംശങ്ങൾ ൮",
          "Policy Details 9": "പോളിസി വിശദാംശങ്ങൾ ൯",
          "Policy Details 10": "പോളിസി വിശദാംശങ്ങൾ ൧൦",
          "Please wait while we verify your recording":
            "നിങ്ങളുടെ റെക്കോർഡിംഗ് പരിശോധിക്കുന്നതിനിടെ ദയവായി കാത്തിരിക്കൂ.",
          Start: "ആരംഭിക്കുക",
          Stop: "നിർത്തുക",
          "You have only one chance left to complete the verification.":
            "പരിശോധന പൂർത്തിയാക്കാൻ നിങ്ങൾക്ക് ഒരു അവസരം മാത്രമേ ബാക്കിയുള്ളു.",
          "Max limit reached Please try after 24 hours":
            "പരമാവധി പരിധി എത്തിയിരിക്കുന്നു. 24 മണിക്കൂറിന് ശേഷം ശ്രമിക്കുക.",
          Close: "അടയ്ക്കുക",
          "Incorrect Input details. Please reach out to our sales representative. [ERR002]": "തെറ്റായ ഇൻപുട്ട് വിശദാംശങ്ങൾ. ദയവായി ഞങ്ങളുടെ വിൽപ്പന പ്രതിനിധിയെ ബന്ധപ്പെടുക. [ERR002]",
          "Application number": "അപേക്ഷ നമ്പർ",
          "Thank you for your response. Our representative will contact you soon.":
            "നിങ്ങളുടെ പ്രതികരണത്തിന് നന്ദി. നമ്മുടെ പ്രതിനിധി ഉടൻ നിങ്ങളുമായി ബന്ധപ്പെടും.",
          Cancel: "റദ്ദാക്കുക",
          "Location permission is denied by user":
            "ലൊക്കേഷൻ അനുവാദം ഉപയോക്താവ് നിരസിച്ചു.",
          "Please allow location service from browser settings to continue.":
            "ദയവായി ബ്രൗസർ സെറ്റിംഗുകളിൽ നിന്ന് ലൊക്കേഷൻ സേവനത്തിന് അനുമതി നൽകുക.",
          "Error accessing location: User denied Geolocation. [ERR001]": "സ്ഥലത്തേക്ക് പ്രവേശിക്കുന്നതിൽ പിശക്: ഉപയോക്താവ് ജിയോളൊക്കേഷൻ നിരസിച്ചു. [ERR001]",
          "Unable to access camera or microphone. Please ensure you have all the necessary permissions. [ERR004]": "ക്യാമറ അല്ലെങ്കിൽ മൈക്രോഫോൺ ആക്‌സസ് ചെയ്യാനാകുന്നില്ല. ആവശ്യമായ എല്ലാ അനുമതികളും നിങ്ങൾക്ക് ഉണ്ടെന്ന് ഉറപ്പാക്കുക. [ERR004]",
          "Record again": "മറ്റൊരു പ്രാവശ്യം റെക്കോർഡ് ചെയ്യുക.",
          "The spoken text is inaccurate. Please try recording again.":
            "പറഞ്ഞ വാചകം ശരിയല്ല. ദയവായി വീണ്ടും റെക്കോർഡ് ചെയ്യാൻ ശ്രമിക്കുക.",
          "Return to homepage": "ഹോംപേജിലേക്ക് മടങ്ങുക.",
          "Your video consent was not successfully recorded. Please restart the process and try again.":
            "നിങ്ങളുടെ വീഡിയോ സമ്മതം വിജയകരമായി റെക്കോർഡ് ചെയ്യപ്പെട്ടില്ല. ദയവായി പ്രക്രിയ പുനരാരംഭിച്ച് വീണ്ടും ശ്രമിക്കുക.",
          "Your video consent could not be recorded due to a device change. Please try again.": "ഉപകരണമാറ്റം കാരണം നിങ്ങളുടെ വീഡിയോ സമ്മതി രേഖപ്പെടുത്താൻ കഴിഞ്ഞില്ല. ദയവായി വീണ്ടും ശ്രമിക്കുക.",
          videoVerificationMessage:
            "വീഡിയോ സ്ഥിരീകരണം പൂർത്തിയാക്കിയതിന് നന്ദി <br className='hidden md:block' /> അപേക്ഷ നമ്പർ {{appNo}}",
          customerCareMessage:
            'നിങ്ങളുടെ പോളിസി രേഖകൾ പ്രസിദ്ധീകരിച്ച ശേഷം നിബന്ധനകളും വ്യവസ്ഥകളും പരിശോധിക്കുക <br className="hidden md:block" /> 30-ദിവസത്തെ സൗജന്യ നോക്കൽ കാലയളവിൽ, നിങ്ങൾക്ക് എന്തെങ്കിലും ആശങ്കയുണ്ടെങ്കിൽ ഞങ്ങളെ ബന്ധപ്പെടുക.<br className="hidden md:block" /> നിങ്ങൾക്ക് ഞങ്ങളെ 18002660-ൽ ബന്ധപ്പെടാനോ, ഞങ്ങളുടെ വെബ്‌സൈറ്റ്/മൊബൈൽ ആപ്പ് സന്ദർശിക്കാനോ കഴിയും.',
          "Please wait while we verify your recording.":
            "നിങ്ങളുടെ റെക്കോർഡിംഗ് പരിശോധിക്കുന്നതിനിടെ ദയവായി കാത്തിരിക്കൂ.",
          timeRemaining: "സമയം ബാക്കി {{timer}} സെക്കൻഡ്",
          "Please hold on while we verify your video":
            "ദയവായി കുറച്ച് സമയം കാത്തിരിക്കുക, ഞങ്ങൾ നിങ്ങളുടെ വീഡിയോ സ്ഥിരീകരിക്കുന്നു",
          "Face detected": "മுகം തിരിച്ചറിഞ്ഞു",
          "Multiple faces detected. Please make sure only one person is in view!":
            "നിറഞ്ഞ മുഖങ്ങൾ കണ്ടെത്തിയിട്ടുണ്ട്. ദയവായി ഉറപ്പാക്കുക, ഒരൊറ്റ വ്യക്തി മാത്രമാണ് ദൃശ്യത്തിലുണ്ടായിരിക്കുക!",
          "Face Match Unsuccessful!": "മുക്ഷോഹിയ്ക്കൽ അസ്ഥിരം!",
          "Make sure a real person is in view and looking towards camera in a well-lit area!":
            "നല്ല വെളിച്ചമുള്ള സ്ഥലത്ത് ക്യാമറയിലേക്ക് നോക്കുന്ന ഒരു യഥാർത്ഥ വ്യക്തി കാഴ്ചയിൽ ഉണ്ടെന്ന് ഉറപ്പാക്കുക!",
          "No face detected. Please ensure your face is clearly visible.":
            "ഒരുപാട് മുഖം കണ്ടെത്തിയില്ല. ദയവായി ഉറപ്പാക്കുക, നിങ്ങളുടെ മുഖം വ്യക്തമായും കാണാം.",
          "You don't have camera permissions, Please give permissions manually":
            "നിങ്ങൾക്ക് ക്യാമറ അനുവദനകൾ ഇല്ല, ദയവായി മാനുവലായി അവകാശങ്ങൾ നൽകി",
          "Meeting connection failed": "മീറ്റിംഗ് കണക്ഷൻ പരാജയപ്പെട്ടു",
          "Meeting connection disconnected abruptly":
            "മീറ്റിംഗ് കണക്ഷൻ അപ്രതീക്ഷിതമായി വിച്ഛേദിക്കപ്പെട്ടു",
          'I hereby give my consent and authorize ICICI Prudential Life Insurance Company by clicking on "Start Your Journey" button to use my photo and video footage for verification purpose and to share my photo and video footage provided herein on confidential basis with ICICI group and/or third-party agencies':
            'ഞാൻ ഇവിടെ എന്റെ സമ്മതം നൽകുന്നു, കൂടാതെ ICICI പ്രുടൻഷ്യൽ ലൈഫ് ഇൻഷുറൻസ് കമ്പനിയെ "നിങ്ങളുടെ അപേക്ഷ പ്രക്രിയ ആരംഭിക്കുക" ബട്ടൺ ക്ലിക്ക് ചെയ്യുന്നതിലൂടെ എന്റെ ഫോട്ടോയും വീഡിയോ ദൃശ്യങ്ങളും സ്ഥിരീകരണത്തിനായി ഉപയോഗിക്കാൻ, കൂടാതെ ICICI ഗ്രൂപ്പിനെയും/അല്ലെങ്കിൽ മൂന്നാം കക്ഷി ഏജൻസികളുമായി രഹസ്യമായ പങ്കിടാൻ അനുവദിക്കുന്നു.',
          "Life assured gender": "ഇന്‍ഷുറന്‍സ് സ്വീകരിച്ച വ്യക്തിയുടെ ലിംഗം",
          "Repeat Details": "വിവരങ്ങൾ ആവർത്തിക്കുക",
          "Premium Amount(Inclusive of all applicable taxes)":
            "പ്രീമിയം തുക (എല്ലാ ബാധകമായ നികുതികൾ ഉൾപ്പെടെ)",
          "Total Premium Amount(Inclusive of all applicable taxes)":
            "മൊത്തം പ്രീമിയം തുക (എല്ലാ ബാധകമായ നികുതികൾ ഉൾപ്പെടെ)",
          "Unable to fetch device details, Please try using another device.":
            "ഉപകരണ വിവരങ്ങൾ പ്രാപ്തമാക്കാനാകുന്നില്ല, ദയവായി മറ്റൊരു ഉപകരണം ഉപയോഗിച്ച് പരിശ്രമിക്കുക.",
          "Starting Your Journey...":
            "നിങ്ങളുടെ അപേക്ഷ പ്രക്രിയ ആരംഭിക്കുന്നു...",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR099]": "അറിയില്ല! എന്തോ പിശക് സംഭവിച്ചു. ദയവായി ഞങ്ങളുടെ വിൽപ്പന പ്രതിനിധിയെ സമീപിക്കുകയോ അല്ലെങ്കിൽ ഞങ്ങൾക്ക് vidassure@iciciprulife.com എന്ന ഇമെയിൽ അയയ്ക്കുകയോ ചെയ്യുക. [ERR099]",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR003]": "അറിയില്ല! എന്തോ പിശക് സംഭവിച്ചു. ദയവായി ഞങ്ങളുടെ വിൽപ്പന പ്രതിനിധിയെ സമീപിക്കുകയോ അല്ലെങ്കിൽ ഞങ്ങൾക്ക് vidassure@iciciprulife.com എന്ന ഇമെയിൽ അയയ്ക്കുകയോ ചെയ്യുക. [ERR003]",
          "Our services are temporarily unavailable. Please try again shortly.": "ഞങ്ങളുടെ സേവനങ്ങൾ താൽക്കാലികമായി ലഭ്യമല്ല. ദയവായി കുറച്ച് നേരം കഴിഞ്ഞ് വീണ്ടും ശ്രമിക്കുക.",
          "Please provide a reason for disagreeing": "അസമ్മതി കാരണം ഇസ്തുന്നാരు",
          "Reason should be less than 100 characters and more than 20 characters": "കാരണം 100 പ്രതീകങ്ങളിൽ കുറവും 20 പ്രതീകങ്ങളിൽ കൂടുതലും ആയിരിക്കണം.",
          "Reason should only contain letters and numbers": "കാരണം അക്ഷരങ്ങളും അക്കങ്ങളും മാത്രമേ അടങ്ങിയിരിക്കണം",
          "Enter your reason for disagreeing here...": "വിയോജിക്കാനുള്ള കാരണം ഇവിടെ നൽകുക...",
          "Submit for Validation": "പരിശോധനയ്ക്കായി സമർപ്പിക്കുക",
          "Your journey is about to expire in one minute. Please complete any pending actions.": "നിങ്ങളുടെ യാത്ര ഒരു മിനിറ്റിനുള്ളിൽ അവസാനിക്കും. ദയവായി ബാക്കി ഉള്ള പ്രവർത്തനങ്ങൾ പൂർത്തിയാക്കുക."

        },
      },
      od: {
        translation: {
          "Proposer Name": "ପ୍ରସ୍ତାବକଙ୍କ ନାମ",
          "Life Assured Name": "ଜୀବନ ବୀମିତଙ୍କ ନାମ",
          "Proposer date of birth": "ପ୍ରସ୍ତାବକଙ୍କ ଜନ୍ମ ତାରିଖ",
          "Registered Email Address": "ପଞ୍ଜୀକୃତ ଇମେଲ୍ ଠିକଣା",
          "Mobile Number": "ମୋବାଇଲ୍ ନମ୍ବର",
          Education: "ଶିକ୍ଷା",
          Occupation: "ପେଶା",
          "Income (per annum)": "ଆୟ (ପ୍ରତି ବର୍ଷ)",
          "Plan Name": "ଯୋଜନା ନାମ",
          "Life CoverSum assured": "ଜୀବନ ବୀମା ସମ୍ପୂର୍ଣ୍ଣ ବୀମିତ ରାଶି",
          "Premium amount": "ପ୍ରୀମିୟମ୍ ରାଶି",
          Frequency: "ପୁନରାବୃତ୍ତି",
          "Premium paying term": "ପ୍ରୀମିୟମ୍ ଦେବାର ଅବଧି",
          "Policy term": "ପଲିସି ଅବଧି",
          "Start Your Journey": "ଆପଣଙ୍କର ଆବେଦନ ପ୍ରକ୍ରିୟା ଆରମ୍ଭ କରନ୍ତୁ",
          "Reference No.": "ସନ୍ଦର୍ଭ ସଂଖ୍ୟା.",
          Language: "ଭାଷା",
          "I Agree": "ମୁଁ ସମ୍ମତ",
          Disagree: "ଅସମ୍ମତ",
          "Personal Details": "ବ୍ୟକ୍ତିଗତ ବିବରଣୀ",
          "Policy Details": "ପଲିସି ବିବରଣୀ",
          "Video Consent": "ଭିଡିଓ ସମ୍ମତି",
          "Please record your video consent by clicking Start and clearly reading the text displayed on the screen. When you're done, click Stop to complete the process.":
            "ଦୟାକରି 'ଆରମ୍ଭ' କ୍ଲିକ୍ କରି ଏବଂ ପରଦାରେ ଦେଖାଯାଉଥିବା ଟେକ୍ସ୍ଟ ପଢି ଆପଣଙ୍କର ଭିଡିଓ ସମ୍ମତି ରେକର୍ଡ କରନ୍ତୁ। ସମାପ୍ତ ହେବା ପରେ, ପ୍ରକ୍ରିୟା ପୂର୍ଣ୍ଣ କରିବାକୁ 'ସ୍ଟପ୍' କ୍ଲିକ୍ କରନ୍ତୁ।",
          "Policy Details 1": "ପଲିସି ବିବରଣୀ 1",
          "Policy Details 2": "ପଲିସି ବିବରଣୀ 2",
          "Policy Details 3": "ପଲିସି ବିବରଣୀ 3",
          "Policy Details 4": "ପଲିସି ବିବରଣୀ 4",
          "Policy Details 5": "ପଲିସି ବିବରଣୀ 5",
          "Policy Details 6": "ପଲିସି ବିବରଣୀ 6",
          "Policy Details 7": "ପଲିସି ବିବରଣୀ 7",
          "Policy Details 8": "ପଲିସି ବିବରଣୀ 8",
          "Policy Details 9": "ପଲିସି ବିବରଣୀ 9",
          "Policy Details 10": "ପଲିସି ବିବରଣୀ 10",
          "Please wait while we verify your recording":
            "ଦୟାକରି ଅପେକ୍ଷା କରନ୍ତୁ ଯେତେବେଳେ ଆମେ ଆପଣଙ୍କର ରେକର୍ଡିଂ ଯାଞ୍ଚ କରୁଛୁ।",
          Start: "ଆରମ୍ଭ କରନ୍ତୁ",
          Stop: "ସ୍ଟପ୍ କରନ୍ତୁ",
          "You have only one chance left to complete the verification.":
            "ପ୍ରମାଣିକରଣ ସମ୍ପୂର୍ଣ୍ଣ କରିବା ପାଇଁ ଆପଣଙ୍କ ପାଖରେ କେବଳ ଗୋଟିଏ ଅବସର ବାକି ଅଛି।",
          "Max limit reached Please try after 24 hours":
            "ସର୍ବାଧିକ ସୀମା ପହଞ୍ଚିଛି, ଦୟାକରି 24 ଘଣ୍ଟା ପରେ ପୁନଃ ଚେଷ୍ଟା କରନ୍ତୁ।",
          Close: "ବନ୍ଦ କରନ୍ତୁ",
          "Incorrect Input details. Please reach out to our sales representative. [ERR002]": "ଭୁଲ୍ ଇନ୍‌ପୁଟ୍ ବିବରଣୀ। ଦୟାକରି ଆମ ନିକଟ ବିକ୍ରୟ ପ୍ରତିନିଧି ସହ ଯୋଗାଯୋଗ କରନ୍ତୁ। [ERR002]",
          "Application number": "ଆବେଦନ ସଂଖ୍ୟା",
          "Thank you for your response. Our representative will contact you soon.":
            "ଆପଣଙ୍କ ଉତ୍ତର ପାଇଁ ଧନ୍ୟବାଦ। ଆମ ପ୍ରତିନିଧି ଶୀଘ୍ର ଆପଣଙ୍କ ସହିତ ସମ୍ପର୍କ କରିବେ।",
          Cancel: "ବାତିଲ୍ କରନ୍ତୁ",
          "Location permission is denied by user":
            "ଉପଯୋଗକାରୀ ଦ୍ଵାରା ଅବସ୍ଥାନ ଅନୁମତି ଅସ୍ଵୀକୃତ।",
          "Please allow location service from browser settings to continue.":
            "ଅଗ୍ରସର ହେବା ପାଇଁ ବ୍ରାଉଜର୍ ସେଟିଂସ୍ ରୁ ଅବସ୍ଥାନ ସେବାକୁ ଅନୁମତି ଦିଅନ୍ତୁ।",
          "Error accessing location: User denied Geolocation. [ERR001]": "ସ୍ଥାନ ଆକ୍ସେସ୍ କରିବାରେ ତ୍ରୁଟି: ଉପଯୋଗକର୍ତ୍ତା ଭୌଗୋଳିକ ସ୍ଥାନକୁ ଅସ୍ୱୀକାର କରିଛନ୍ତି। [ERR001]",
          "Unable to access camera or microphone. Please ensure you have all the necessary permissions. [ERR004]": "କ୍ୟାମେରା କିମ୍ବା ମାଇକ୍ରୋଫୋନ୍‌କୁ ଆକ୍ସେସ୍‌ ମିଳୁନାହିଁ। ଦୟାକରି ଆପଣ ଆବଶ୍ୟକ ସମସ୍ତ ଅନୁମତି ଦେଇଛନ୍ତି କି ନାହିଁ ନିଶ୍ଚିତ କରନ୍ତୁ। [ERR004]",
          "Record again": "ପୁନଃ ରେକର୍ଡ କରନ୍ତୁ",
          "The spoken text is inaccurate. Please try recording again.":
            "କୁହାଯାଇଥିବା ଲେଖାଟି ସଠିକ୍ ନାହିଁ। ଦୟାକରି ପୁଣି ଥରେ ରେକର୍ଡିଂ କରିବାକୁ ଚେଷ୍ଟା କରନ୍ତୁ।",
          "Return to homepage": "ମୂଳ ପୃଷ୍ଠାକୁ ଫେରନ୍ତୁ",
          "Your video consent was not successfully recorded. Please restart the process and try again.":
            "ଆପଣଙ୍କର ଭିଡିଓ ସମମତି ସଫଳଭାବେ ରେକର୍ଡ ହୋଇନାହିଁ। ଦୟାକରି ପୁନର୍ବାର ପ୍ରକ୍ରିୟା ଆରମ୍ଭ କରନ୍ତୁ ଏବଂ ପୁନଃଚେଷ୍ଟା କରନ୍ତୁ।",
          "Your video consent could not be recorded due to a device change. Please try again.": "ଡିଭାଇସ ପରିବର୍ତ୍ତନ ପାଇଁ ଆପଣଙ୍କର ଭିଡିଓ ସମ୍ମତି ରେକର୍ଡ ହେବାକୁ ବାଞ୍ଛିତ ହୋଇନାହିଁ। ଦୟାକରି ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ।",
          videoVerificationMessage:
            "ଭିଡିଓ ସତ୍ୟାପନ ସମାପ୍ତ କରିଥିବା ପାଇଁ ଧନ୍ୟବାଦ <br className='hidden md:block' /> ଆବେଦନ ସଂଖ୍ୟା {{appNo}}",
          customerCareMessage:
            'ପଲିସି ଜାରିହେବା ପରେ ନିୟମ ଏବଂ ନିବନ୍ଧନ ଯାଞ୍ଚ କରିବାକୁ ଦୟାକରି ଆପଣଙ୍କର ନୀତି ଦଲିଲ ଦେଖନ୍ତୁ <br className="hidden md:block" /> 30-ଦିନ ମାଗଣା ଦୃଷ୍ଟି ପରିଖ୍ୟା ଅବଧି ଭିତରେ ଏବଂ ଯଦି କୌଣସି ଚିନ୍ତା ଥାଏ, ତେବେ ଆମ ସହ ଯୋଗାଯୋଗ କରନ୍ତୁ।. <br className="hidden md:block" /> ଆପଣ 18002660 ରେ ଆମ ସହିତ ଯୋଗାଯୋଗ କରିପାରିବେ କିମ୍ବା ଆମ ୱେବସାଇଟ୍/ମୋବାଇଲ୍ ଆପ୍ ପରିଦର୍ଶନ କରିପାରିବେ।',
          "Please wait while we verify your recording.":
            "ଦୟାକରି ଅପେକ୍ଷା କରନ୍ତୁ, ଆମେ ଆପଣଙ୍କର ରେକର୍ଡିଂ ସତ୍ୟାପନ କରୁଛୁ।",
          timeRemaining: "ଅବଶିଷ୍ଟ ସମୟ {{timer}} ସେକେଣ୍ଡ",
          "Please hold on while we verify your video":
            "ଦୟାକରି ଅପେକ୍ଷା କରନ୍ତୁ, ଆମେ ଆପଣଙ୍କର ଭିଡିଓ ସତ୍ୟାପନ କରୁଛୁ।",
          "Face detected": "ମୁହଁ ଚିହ୍ନଟ ହୋଇଛି",
          "Multiple faces detected. Please make sure only one person is in view!":
            "ଏକାଧିକ ମୁହଁ ଚିହ୍ନଟ ହୋଇଛି। ଦୟାକରି ନିଶ୍ଚିତ କରନ୍ତୁ ଯେ କେବଳ ଏକ ମଣିଷ ଦୃଶ୍ୟରେ ଅଛନ୍ତି!",
          "Face Match Unsuccessful!": "ମୁହଁ ମିଳିବା ବିଫଳ!",
          "Make sure a real person is in view and looking towards camera in a well-lit area!":
            "ନିଶ୍ଚିତ କରନ୍ତୁ ଯେ ଏକ ପ୍ରକୃତିକ ବ୍ୟକ୍ତି ଭଲ ଆଲୋକିତ ସ୍ଥାନରେ କ୍ୟାମେରା ଦିଗରେ ଦେଖୁଛନ୍ତି!",
          "No face detected. Please ensure your face is clearly visible.":
            "କୌଣସି ମୁହଁ ଚିହ୍ନଟ ହୋଇନାହିଁ। ଦୟାକରି ନିଶ୍ଚିତ କରନ୍ତୁ ଯେ ଆପଣଙ୍କର ମୁହଁ ସ୍ପଷ୍ଟ ଭାବରେ ଦୃଶ୍ୟମାନ।",
          "You don't have camera permissions, Please give permissions manually":
            "ଆପଣଙ୍କର କ୍ୟାମେରା ଅନୁମତି ନାହିଁ, ଦୟାକରି ମାନୁଆଲ୍ ଭାବରେ ଅନୁମତି ଦିଅନ୍ତୁ",
          "Meeting connection failed": "ମିଟିଂ ଯୋଗ ସଂଯୋଗ ବିଫଳ ହୋଇଛି",
          "Meeting connection disconnected abruptly":
            "ମିଟିଂ ସଂଯୋଗ ଅଚାନକ ବିଚ୍ଛିନ୍ନ ହୋଇଗଲା",
          'I hereby give my consent and authorize ICICI Prudential Life Insurance Company by clicking on "Start Your Journey" button to use my photo and video footage for verification purpose and to share my photo and video footage provided herein on confidential basis with ICICI group and/or third-party agencies':
            'ମୁଁ ଏଠାରେ ମୋର ସମ୍ମତି ପ୍ରଦାନ କରୁଛି ଏବଂ ICICI ପ୍ରୁଡେନ୍ସିଆଲ୍ ଲାଇଫ୍ ଇନସୁରାନ୍ସ କମ୍ପାନୀକୁ "ଆପଣଙ୍କର ଆବେଦନ ପ୍ରକ୍ରିୟା ଆରମ୍ଭ କରନ୍ତୁ" ବଟନ୍ ଉପରେ କ୍ଲିକ୍ କରି ମୋର ଫଟୋ ଏବଂ ଭିଡିଓ ଫୁଟେଜ୍ ଯାଞ୍ଚକରଣ ଉଦ୍ଦେଶ୍ୟରେ ବ୍ୟବହାର କରିବାକୁ ଏବଂ ଏଠାରେ ପ୍ରଦାନ କରାଯାଇଥିବା ମୋର ଫଟୋ ଏବଂ ଭିଡିଓ ଫୁଟେଜ୍ ଗୋପନୀୟ ଭାବରେ ICICI ଗୋଷ୍ଠୀ ଏବଂ/କିମ୍ବା ତୃତୀୟ-ପକ୍ଷ ଏଜେନ୍ସିଗୁଡ଼ିକ ସହିତ ସେୟାର କରିବାକୁ ଅନୁମତି ଦେଉଛି।',
          "Life assured gender": "ବୀମା ହୋଇଥିବା ବ୍ୟକ୍ତିଙ୍କ ଲିଙ୍ଗ",
          "Repeat Details": "ବିବରଣୀ ପୁନରାବୃତ୍ତ କରନ୍ତୁ",
          "Premium Amount(Inclusive of all applicable taxes)":
            "ପ୍ରିମିୟମ୍ ରାଶି (ସମସ୍ତ ପ୍ରୟୋଜ୍ୟ କର ସମେତ)",
          "Total Premium Amount(Inclusive of all applicable taxes)":
            "ମୋଟ ପ୍ରିମିୟମ୍ ରାଶି (ସମସ୍ତ ପ୍ରୟୋଜ୍ୟ କର ସମେତ)",
          "Unable to fetch device details, Please try using another device.":
            "ଡିଭାଇସ୍ ବିବରଣୀ ଆଣିପାରିଲା ନାହିଁ, ଦୟାକରି ଅନ୍ୟ ଏକ ଡିଭାଇସ୍ ବ୍ୟବହାର କରି ଚେଷ୍ଟା କରନ୍ତୁ।",
          "Starting Your Journey...": "ଆପଣଙ୍କର ଯାତ୍ରା ଆରମ୍ଭ ହେଉଛି...",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR099]": "ଉଫ୍! କିଛି ତ୍ରୁଟି ଘଟିଛି। ଦୟାକରି ଆମ ସେଲ୍ସ୍ ପ୍ରତିନିଧିଙ୍କ ସହ ଯୋଗାଯୋଗ କରନ୍ତୁ କିମ୍ବା vidassure@iciciprulife.com ରେ ଆମକୁ ଲେଖନ୍ତୁ। [ERR099]",
          "Oops! Some error occurred. Please reach out to our sales representative or write to us at vidassure@iciciprulife.com [ERR003]": "ଉଫ୍! କିଛି ତ୍ରୁଟି ଘଟିଛି। ଦୟାକରି ଆମ ସେଲ୍ସ୍ ପ୍ରତିନିଧିଙ୍କ ସହ ଯୋଗାଯୋଗ କରନ୍ତୁ କିମ୍ବା vidassure@iciciprulife.com ରେ ଆମକୁ ଲେଖନ୍ତୁ। [ERR003]",
          "Our services are temporarily unavailable. Please try again shortly.": "ଆମ ସେବାଗୁଡ଼ିକ ଅସ୍ଥାୟୀଭାବେ ଅପଲବ୍ଧ ନୁହେଁ। ଦୟାକରି କିଛି ସମୟ ପରେ ପୁଣିଥରେ ଚେଷ୍ଟା କରନ୍ତୁ।",
          "Please provide a reason for disagreeing": "ଅସମ୍ମତି କାରଣ ଦାଖଲ କରନ୍ତୁ",
          "Reason should be less than 100 characters and more than 20 characters": "କାରଣ ସଂଖ୍ୟା 100 ଅକ୍ଷରରୁ କମ୍ ଏବଂ 20 ଅକ୍ଷରରୁ ଅଧିକ ହେବା ଉଚିତ।",
          "Reason should only contain letters and numbers": "କାରଣରେ କେବଳ ଅକ୍ଷର ଏବଂ ସଂଖ୍ୟା ରହିବା ଉଚିତ",
          "Enter your reason for disagreeing here...": "ଆପଣଙ୍କର ଅସହମତ ହେବାର କାରଣ ଏଠାରେ ଲେଖନ୍ତୁ...",
          "Submit for Validation": "ମାନ୍ୟତା ପାଇଁ ଦାଖଲ କରନ୍ତୁ",
          "Your journey is about to expire in one minute. Please complete any pending actions.": "ଆପଣଙ୍କ ଯାତ୍ରା ଗୋଟିଏ ମିନିଟ୍‌ ମଧ୍ୟରେ ସମାପ୍ତ ହେବ। ଦୟାକରି ବକେୟା କାମଗୁଡିକ ସମ୍ପୂର୍ଣ୍ଣ କରନ୍ତୁ।"

        },
      }
    },
  });

// Update the <html> tag with the current language
i18n.on("languageChanged", (lng) => {
  const languageFonts = {
    en: "Noto Sans, Arial, sans-serif",
    "te-IN": "Noto Sans Telugu, sans-serif",
    "hi-IN": "Noto Sans Devanagari, sans-serif",
    "mr-IN": "Noto Sans Devanagari, sans-serif",
    "pa-IN": "Noto Sans Gurmukhi, sans-serif",
    "bn-IN": "Noto Sans Bengali, sans-serif",
    "kn-IN": "Noto Sans Kannada, sans-serif",
    "ta-IN": "Noto Sans Tamil, sans-serif",
    "ml-IN": "Noto Sans Malayalam, sans-serif",
    "gu-IN": "Noto Sans Gujarati, sans-serif",
    "od-IN": "Noto Sans Oriya, sans-serif",

    // Add other fonts here as needed
  };

  // Set the font on body
  document.documentElement.style.fontFamily = languageFonts[lng] || "Noto Sans";
});

export default i18n;
